<div class="container-fluid">
  <div class="modal-edicao-topo" *ngIf="modoModal">
    <h2 class="modal-edicao-titulo">{{ idPacienteEdicao > 0 ? 'Editar cliente' : 'Novo cliente' }}</h2>
    <button
      type="button"
      class="btn btn-outline-secondary btn-sm"
      (click)="solicitarFecharModal()"
      aria-label="Fechar">
      <i class="fas fa-times"></i> Fechar
    </button>
  </div>
  <!-- Navegação por Abas -->
  <div class="tabs-container">
    <nav class="tabs-nav" *ngIf="!somenteAbaCliente">
      <ul class="tabs-list">
        <li class="tab-item" [class.active]="abaAtiva === 'cliente'" (click)="selecionarAba('cliente')">
          <i class="fas fa-user"></i>
          <span>Cliente</span>
        </li>
        <li class="tab-item" [class.active]="abaAtiva === 'comunicacao'" (click)="selecionarAba('comunicacao')">
          <i class="fas fa-comments"></i>
          <span>Comunicação</span>
        </li>
        <li class="tab-item" [class.active]="abaAtiva === 'servicos'" (click)="selecionarAba('servicos')">
          <i class="fas fa-cogs"></i>
          <span>Serviços</span>
        </li>
        <li class="tab-item" [class.active]="abaAtiva === 'documento'" (click)="selecionarAba('documento')">
          <i class="fas fa-file-alt"></i>
          <span>Documento</span>
        </li>
        <li class="tab-item" [class.active]="abaAtiva === 'arvore'" (click)="selecionarAba('arvore')">
          <i class="fas fa-tree"></i>
          <span>Árvore</span>
        </li>
        <li class="tab-item" [class.active]="abaAtiva === 'orcamentos'" (click)="selecionarAba('orcamentos')">
          <i class="fas fa-dollar-sign"></i>
          <span>Orçamentos</span>
        </li>
        <li class="tab-item" [class.active]="abaAtiva === 'sharepoint'" (click)="selecionarAba('sharepoint')">
          <i class="fas fa-cloud"></i>
          <span>Sharepoint</span>
        </li>
        <li class="tab-item" [class.active]="abaAtiva === 'responsavel'" (click)="selecionarAba('responsavel')">
          <i class="fas fa-user-tie"></i>
          <span>Responsável</span>
        </li>
      </ul>
    </nav>

    <div
      class="cadastro-cliente-layout layout-duas-colunas"
      [class.contexto-colapsado]="!contextoGlobalExpandido">
      <div
        class="cliente-contexto-global"
        [class.is-readonly]="abaAtiva !== 'cliente'"
        [formGroup]="formCliente">
        <div class="cliente-contexto-global-header">
          <span>Informações do Cliente</span>
          <button
            type="button"
            class="btn-cliente-contexto-toggle"
            (click)="toggleContextoGlobalExpandido()">
            <i class="fas" [ngClass]="contextoGlobalExpandido ? 'fa-eye-slash' : 'fa-eye'"></i>
            <span class="btn-cliente-contexto-toggle-text">{{ contextoGlobalExpandido ? 'Ocultar' : 'Mostrar' }}</span>
          </button>
        </div>

        <div *ngIf="contextoGlobalExpandido" class="cliente-contexto-global-conteudo">
          <div class="cliente-contexto-global-nome">
            <label>Cliente: <span class="cliente-contexto-global-nome-valor">{{ formCliente.get('nome')?.value || 'Não informado' }}</span></label>
          </div>

          <div class="cliente-contexto-global-row">
            <div class="form-group cliente-contexto-global-switch">
              <label for="pasta_fisica_global">Pasta Física?</label>
              <div class="toggle-container">
                <label class="toggle-switch">
                  <input type="checkbox" id="pasta_fisica_global" formControlName="pasta_fisica" [disabled]="abaAtiva !== 'cliente'">
                  <span class="toggle-slider"></span>
                </label>
                <span class="toggle-label">{{ formCliente.get('pasta_fisica')?.value ? 'Sim' : 'Não' }}</span>
              </div>
            </div>
          </div>

          <div class="form-group cliente-contexto-global-link">
            <label for="link_pasta_global">Link Pasta Virtual</label>
            <input
              type="url"
              id="link_pasta_global"
              formControlName="link_pasta"
              class="form-control"
              [readonly]="abaAtiva !== 'cliente'"
              placeholder="https://exemplo.com/pasta">
          </div>

          <div class="form-group cliente-contexto-global-link-apelido">
            <label for="apelido_pasta_virtual_global">Apelido Pasta Virtual</label>
            <input
              type="text"
              id="apelido_pasta_virtual_global"
              formControlName="apelido_pasta_virtual"
              class="form-control"
              [readonly]="abaAtiva !== 'cliente'"
              placeholder="Ex.: Pasta Família Rossi">
          </div>

          <div class="form-group cliente-contexto-global-observacao">
            <label for="observacoes_global">Historico</label>
            <div
              id="observacoes_global"
              class="form-control observacao-preview"
              [innerHTML]="getObservacaoContextoPreview()">
            </div>
            <button
              type="button"
              class="btn-observacao-expandir"
              (click)="abrirModalObservacaoContextoGlobal()">
              Expandir observação
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="modalObservacaoContextoGlobalAberto" class="modal-observacao-overlay">
        <div class="modal-observacao-box modal-observacao-contexto-box">
          <h4>Historico</h4>
          <div class="orcamento-observacao-toolbar" [class.is-disabled]="!podeEditarObservacaoContextoGlobal">
            <button type="button" class="btn btn-toolbar-mini" title="Negrito" (click)="executarComandoObservacaoContextoGlobal('bold')" [disabled]="!podeEditarObservacaoContextoGlobal">
              <i class="fas fa-bold"></i>
            </button>
            <button type="button" class="btn btn-toolbar-mini" title="Itálico" (click)="executarComandoObservacaoContextoGlobal('italic')" [disabled]="!podeEditarObservacaoContextoGlobal">
              <i class="fas fa-italic"></i>
            </button>
            <button type="button" class="btn btn-toolbar-mini" title="Sublinhado" (click)="executarComandoObservacaoContextoGlobal('underline')" [disabled]="!podeEditarObservacaoContextoGlobal">
              <i class="fas fa-underline"></i>
            </button>
            <span class="toolbar-mini-sep"></span>
            <button type="button" class="btn btn-toolbar-mini" title="Lista com marcadores" (click)="executarComandoObservacaoContextoGlobal('insertUnorderedList')" [disabled]="!podeEditarObservacaoContextoGlobal">
              <i class="fas fa-list-ul"></i>
            </button>
            <button type="button" class="btn btn-toolbar-mini" title="Lista numerada" (click)="executarComandoObservacaoContextoGlobal('insertOrderedList')" [disabled]="!podeEditarObservacaoContextoGlobal">
              <i class="fas fa-list-ol"></i>
            </button>
            <span class="toolbar-mini-sep"></span>
            <button type="button" class="btn btn-toolbar-mini" title="Alinhar à esquerda" (click)="executarComandoObservacaoContextoGlobal('justifyLeft')" [disabled]="!podeEditarObservacaoContextoGlobal">
              <i class="fas fa-align-left"></i>
            </button>
            <button type="button" class="btn btn-toolbar-mini" title="Centralizar" (click)="executarComandoObservacaoContextoGlobal('justifyCenter')" [disabled]="!podeEditarObservacaoContextoGlobal">
              <i class="fas fa-align-center"></i>
            </button>
            <button type="button" class="btn btn-toolbar-mini" title="Alinhar à direita" (click)="executarComandoObservacaoContextoGlobal('justifyRight')" [disabled]="!podeEditarObservacaoContextoGlobal">
              <i class="fas fa-align-right"></i>
            </button>
            <span class="toolbar-mini-sep"></span>
            <button type="button" class="btn btn-toolbar-mini" title="Desfazer" (click)="executarComandoObservacaoContextoGlobal('undo')" [disabled]="!podeEditarObservacaoContextoGlobal">
              <i class="fas fa-undo"></i>
            </button>
            <button type="button" class="btn btn-toolbar-mini" title="Refazer" (click)="executarComandoObservacaoContextoGlobal('redo')" [disabled]="!podeEditarObservacaoContextoGlobal">
              <i class="fas fa-redo"></i>
            </button>
          </div>
          <div
            #observacaoContextoGlobalEditor
            id="observacoes_global_modal"
            class="orcamento-observacao-impressao-editor observacao-contexto-editor"
            [class.is-readonly]="!podeEditarObservacaoContextoGlobal"
            [attr.contenteditable]="podeEditarObservacaoContextoGlobal ? 'true' : 'false'"
            (input)="onObservacaoContextoGlobalInput($event)"
            (keydown)="onObservacaoContextoGlobalKeydown($event)"
            (paste)="onObservacaoContextoGlobalPaste($event)">
          </div>
          <div class="modal-observacao-acoes">
            <button type="button" class="btn btn-secondary" (click)="fecharModalObservacaoContextoGlobal()" [disabled]="salvandoObservacaoContextoGlobal">
              Fechar
            </button>
            <button
              type="button"
              class="btn btn-success"
              (click)="salvarObservacaoContextoGlobal()"
              [disabled]="!podeSalvarObservacaoContextoGlobal"
              [title]="!clienteJaCadastrado ? 'Salve o cadastro do cliente antes de gravar a observação' : ''">
              <i class="fa fa-save"></i> Salvar
            </button>
          </div>
        </div>
      </div>

      <!-- Conteúdo das Abas -->
      <div class="tab-content">
      <!-- Aba Cliente -->
      <div class="tab-pane" [class.active]="abaAtiva === 'cliente'">
        
        <div class="tab-body tab-body--cliente-compact">
          <!-- Formulário de Cadastro de Cliente -->
          <form [formGroup]="formCliente" (ngSubmit)="salvarCliente()" class="form-cliente form-cliente--compact">
            
            <!-- Dados Pessoais -->
            <div class="form-section">
              <div class="form-row three-columns">
                <div class="form-group">
                  <label for="sobrenome">Sobrenome</label>
                  <input
                    type="text"
                    id="sobrenome"
                    formControlName="sobrenome"
                    class="form-control"
                    placeholder="Digite o sobrenome">
                </div>
                <div class="form-group">
                  <label for="nome">Nome *</label>
                  <input 
                    type="text" 
                    id="nome" 
                    formControlName="nome" 
                    class="form-control" 
                    [class.is-invalid]="isCampoInvalido('nome')"
                    placeholder="Digite o nome">
                  <div class="invalid-feedback" *ngIf="isCampoInvalido('nome')">
                    {{ getMensagemErro('nome') }}
                  </div>
                </div>
                <div class="form-group">
                  <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-1">
                    <label for="cpf" class="mb-0">{{ rotuloDocumento }} *</label>
                    <div class="d-flex align-items-center gap-3 small">
                      <div class="form-check form-check-inline mb-0 me-0">
                        <input class="form-check-input" type="radio" id="tipoPessoaPF" name="tipoPessoa"
                          [checked]="tipoPessoa === 'PF'" (change)="alterarTipoPessoa('PF')">
                        <label class="form-check-label" for="tipoPessoaPF">Pessoa Física</label>
                      </div>
                      <div class="form-check form-check-inline mb-0 me-0">
                        <input class="form-check-input" type="radio" id="tipoPessoaPJ" name="tipoPessoa"
                          [checked]="tipoPessoa === 'PJ'" (change)="alterarTipoPessoa('PJ')">
                        <label class="form-check-label" for="tipoPessoaPJ">Pessoa Jurídica</label>
                      </div>
                    </div>
                  </div>
                  <input 
                    type="text" 
                    id="cpf" 
                    formControlName="cpf" 
                    (input)="onCpfInput()"
                    class="form-control" 
                    [class.is-invalid]="isCampoInvalido('cpf')"
                    [placeholder]="placeholderDocumento">
                  <div class="invalid-feedback" *ngIf="isCampoInvalido('cpf')">
                    {{ getMensagemErro('cpf') }}
                  </div>
                </div>
              </div>

              <div class="form-row two-columns">
                <div class="form-group">
                  <label for="email">Email/Login *</label>
                  <input 
                    type="email" 
                    id="email" 
                    formControlName="email" 
                    class="form-control" 
                    [class.is-invalid]="isCampoInvalido('email')"
                    placeholder="exemplo@email.com">
                  <div class="invalid-feedback" *ngIf="isCampoInvalido('email')">
                    {{ getMensagemErro('email') }}
                  </div>
                </div>
                <div class="form-group">
                  <label for="senha">
                    Senha de Acesso Plataforma<span *ngIf="idPacienteEdicao <= 0"> *</span>
                  </label>
                  <input 
                    type="password" 
                    id="senha" 
                    formControlName="senha" 
                    class="form-control" 
                    autocomplete="new-password"
                    [class.is-invalid]="isCampoInvalido('senha')"
                    [placeholder]="idPacienteEdicao > 0 ? 'Deixe em branco para manter a atual' : 'Digite a senha'">
                  <div class="invalid-feedback" *ngIf="isCampoInvalido('senha')">
                    {{ getMensagemErro('senha') }}
                  </div>
                </div>
              </div>

              <div class="form-row two-columns">
                <div class="form-group">
                  <label for="telefone_celular">Telefone Celular *</label>
                  <input 
                    type="tel" 
                    id="telefone_celular" 
                    formControlName="telefone_celular" 
                    (input)="onTelefoneInput('telefone_celular')"
                    class="form-control" 
                    [class.is-invalid]="isCampoInvalido('telefone_celular')"
                    placeholder="(00) 00000-0000">
                  <div class="invalid-feedback" *ngIf="isCampoInvalido('telefone_celular')">
                    {{ getMensagemErro('telefone_celular') }}
                  </div>
                </div>
                <div class="form-group">
                  <label for="telefone_adicional">Telefone Adicional</label>
                  <input 
                    type="tel" 
                    id="telefone_adicional" 
                    formControlName="telefone_adicional" 
                    (input)="onTelefoneInput('telefone_adicional')"
                    class="form-control" 
                    placeholder="(00) 00000-0000">
                </div>
              </div>
            </div>

            <!-- Endereço -->
            <div class="form-section">
              <div class="form-row form-row-endereco-linha1">
                <div class="form-group">
                  <label for="rua">Logradouro *</label>
                  <input 
                    type="text" 
                    id="rua" 
                    formControlName="rua" 
                    class="form-control" 
                    [class.is-invalid]="isCampoInvalido('rua')"
                    placeholder="Rua, Avenida, etc.">
                  <div class="invalid-feedback" *ngIf="isCampoInvalido('rua')">
                    {{ getMensagemErro('rua') }}
                  </div>
                </div>
                <div class="form-group">
                  <label for="numero">Número *</label>
                  <input 
                    type="text" 
                    id="numero" 
                    formControlName="numero" 
                    class="form-control" 
                    [class.is-invalid]="isCampoInvalido('numero')"
                    placeholder="123">
                  <div class="invalid-feedback" *ngIf="isCampoInvalido('numero')">
                    {{ getMensagemErro('numero') }}
                  </div>
                </div>
                <div class="form-group">
                  <label for="complemento">Complemento</label>
                  <input 
                    type="text" 
                    id="complemento" 
                    formControlName="complemento" 
                    class="form-control" 
                    placeholder="Apartamento, bloco, etc.">
                </div>
                <div class="form-group">
                  <label for="bairro">Bairro *</label>
                  <input 
                    type="text" 
                    id="bairro" 
                    formControlName="bairro" 
                    class="form-control" 
                    [class.is-invalid]="isCampoInvalido('bairro')"
                    placeholder="Nome do bairro">
                  <div class="invalid-feedback" *ngIf="isCampoInvalido('bairro')">
                    {{ getMensagemErro('bairro') }}
                  </div>
                </div>
              </div>

              <div class="form-row form-row-endereco-linha2">
                <div class="form-group">
                  <label for="cep">CEP *</label>
                  <input 
                    type="text" 
                    id="cep" 
                    formControlName="cep" 
                    (input)="onCepInput()"
                    class="form-control" 
                    [class.is-invalid]="isCampoInvalido('cep')"
                    placeholder="00000-000">
                  <div class="invalid-feedback" *ngIf="isCampoInvalido('cep')">
                    {{ getMensagemErro('cep') }}
                  </div>
                </div>
                <div class="form-group">
                  <label for="pais">País *</label>
                  <select 
                    id="pais" 
                    formControlName="pais" 
                    (change)="onPaisChange()"
                    class="form-control" 
                    [class.is-invalid]="isCampoInvalido('pais')">
                    <option value="">Selecione o país</option>
                    <option *ngFor="let pais of paisesDisponiveis" [value]="pais">
                      {{ pais === 'Italia' ? 'Itália' : pais }}
                    </option>
                  </select>
                  <div class="invalid-feedback" *ngIf="isCampoInvalido('pais')">
                    {{ getMensagemErro('pais') }}
                  </div>
                </div>
                <div class="form-group">
                  <label for="estado">Estado *</label>
                  <select 
                    id="estado" 
                    formControlName="estado" 
                    (change)="onEstadoChange()"
                    class="form-control" 
                    [class.is-invalid]="isCampoInvalido('estado')">
                    <option [ngValue]="null">Selecione o estado</option>
                    <option *ngFor="let estado of estadosDisponiveis" [ngValue]="estado.id">
                      {{ estado.text }}
                    </option>
                  </select>
                  <div class="invalid-feedback" *ngIf="isCampoInvalido('estado')">
                    {{ getMensagemErro('estado') }}
                  </div>
                </div>
                <div class="form-group">
                  <label for="cidade">Cidade <span class="text-danger">*</span></label>
                  <div class="position-relative">
                    <input
                      id="cidade"
                      type="text"
                      class="form-control"
                      [(ngModel)]="cidadeBuscaTexto"
                      [ngModelOptions]="{standalone: true}"
                      (input)="onCidadeInputChange()"
                      (ngModelChange)="atualizarEstadoSalvarCliente()"
                      (focus)="abrirListaCidades()"
                      (blur)="onCidadeBlur()"
                      [class.is-invalid]="isCampoInvalido('cidade')"
                      placeholder="Selecione ou busque a cidade">
                    <input type="hidden" formControlName="cidade">

                    <div
                      class="list-group position-absolute w-100 mt-1"
                      style="top: 100%; z-index: 1000; max-height: 260px; overflow-y: auto;"
                      *ngIf="mostrarListaCidades">
                      <button
                        type="button"
                        class="list-group-item list-group-item-action"
                        *ngFor="let cidade of cidadesFiltradas"
                        (mousedown)="selecionarCidade(cidade)">
                        {{ cidade.text }}
                      </button>
                      <div class="list-group-item text-muted" *ngIf="cidadesFiltradas.length === 0">
                        Nenhuma cidade encontrada
                      </div>
                    </div>
                  </div>
                  <div class="invalid-feedback" *ngIf="isCampoInvalido('cidade')">
                    {{ getMensagemErro('cidade') }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Botões de Ação -->
            <div class="form-actions">
              <button type="button" class="btn btn-secondary" (click)="limparFormulario()">
                <i class="fas fa-eraser"></i> Limpar
              </button>
              <button type="submit" class="btn btn-primary" [disabled]="!formClientePodeSalvar">
                <i class="fas fa-save"></i> Salvar Cliente
              </button>
            </div>
            <p class="text-danger small mb-0 mt-2" *ngIf="!formClientePodeSalvar && camposPendentesSalvarCliente.length">
              Pendente: {{ camposPendentesSalvarCliente.join(', ') }}.
            </p>
          </form>
        </div>
      </div>

      <!-- Aba Comunicação -->
      <div class="tab-pane" [class.active]="abaAtiva === 'comunicacao'">
        <div class="tab-header">
          <h2><i class="fas fa-comments"></i> Comunicação</h2>
        </div>
        <div class="tab-body">
          
          <!-- Sistema de Chat -->
          <div class="chat-container">
            
            <!-- Cabeçalho do Chat -->
            <div class="chat-header">
              <div class="chat-user-info">
                <div class="user-avatar">
                  <i class="fas fa-user"></i>
                </div>
                <div class="user-details">
                  <h3>{{ formCliente.get('nome')?.value || 'Cliente' }}</h3>
                  <span class="user-status" [class.online]="clienteOnline">
                    <i class="fas fa-circle"></i>
                    {{ clienteOnline ? 'Online' : 'Offline' }}
                  </span>
                </div>
              </div>
              <div class="chat-actions">
                <button class="btn btn-sm btn-outline" (click)="limparChat()" title="Limpar Chat">
                  <i class="fas fa-trash"></i>
                </button>
                <button class="btn btn-sm btn-outline" (click)="exportarChat()" title="Exportar Chat">
                  <i class="fas fa-download"></i>
                </button>
              </div>
            </div>
            
            <!-- Área de Mensagens -->
            <div class="chat-messages" #chatMessages>
              <div class="messages-container">
                
                <!-- Mensagem de exemplo - Empresa -->
                <div class="message message-empresa">
                  <div class="message-avatar">
                    <i class="fas fa-building"></i>
                  </div>
                  <div class="message-content">
                    <div class="message-header">
                      <span class="sender-name">Empresa</span>
                      <span class="message-time">10:30</span>
                    </div>
                    <div class="message-text">
                      Olá! Como posso ajudá-lo hoje?
                    </div>
                  </div>
                </div>
                
                <!-- Mensagem de exemplo - Cliente -->
                <div class="message message-cliente">
                  <div class="message-avatar">
                    <i class="fas fa-user"></i>
                  </div>
                  <div class="message-content">
                    <div class="message-header">
                      <span class="sender-name">Cliente</span>
                      <span class="message-time">10:32</span>
                    </div>
                    <div class="message-text">
                      Gostaria de saber sobre o status do meu processo de cidadania italiana.
                    </div>
                  </div>
                </div>
                
                <!-- Mensagem de exemplo - Empresa -->
                <div class="message message-empresa">
                  <div class="message-avatar">
                    <i class="fas fa-building"></i>
                  </div>
                  <div class="message-content">
                    <div class="message-header">
                      <span class="sender-name">Empresa</span>
                      <span class="message-time">10:35</span>
                    </div>
                    <div class="message-text">
                      Claro! Vou verificar o status do seu processo. Um momento, por favor.
                    </div>
                  </div>
                </div>
                
                <!-- Mensagem de exemplo - Empresa -->
                <div class="message message-empresa">
                  <div class="message-avatar">
                    <i class="fas fa-building"></i>
                  </div>
                  <div class="message-content">
                    <div class="message-header">
                      <span class="sender-name">Empresa</span>
                      <span class="message-time">10:37</span>
                    </div>
                    <div class="message-text">
                      Seu processo está em andamento na fase de documentação. Precisamos de alguns documentos adicionais que já enviamos por email.
                    </div>
                  </div>
                </div>
                
                <!-- Mensagem de exemplo - Cliente -->
                <div class="message message-cliente">
                  <div class="message-avatar">
                    <i class="fas fa-user"></i>
                  </div>
                  <div class="message-content">
                    <div class="message-header">
                      <span class="sender-name">Cliente</span>
                      <span class="message-time">10:40</span>
                    </div>
                    <div class="message-text">
                      Perfeito! Vou enviar os documentos solicitados ainda hoje. Obrigado pela informação!
                    </div>
                  </div>
                </div>
                
                <!-- Mensagem de exemplo - Empresa -->
                <div class="message message-empresa">
                  <div class="message-avatar">
                    <i class="fas fa-building"></i>
                  </div>
                  <div class="message-content">
                    <div class="message-header">
                      <span class="sender-name">Empresa</span>
                      <span class="message-time">10:42</span>
                    </div>
                    <div class="message-text">
                      Excelente! Assim que recebermos os documentos, daremos continuidade ao processo. Qualquer dúvida, estou à disposição!
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
            
            <!-- Área de Digitação -->
            <div class="chat-input">
              <div class="input-container">
                <div class="input-actions">
                  <button class="btn btn-sm btn-outline" (click)="anexarArquivo()" title="Anexar Arquivo">
                    <i class="fas fa-paperclip"></i>
                  </button>
                  <button class="btn btn-sm btn-outline" (click)="enviarEmoji()" title="Emoji">
                    <i class="fas fa-smile"></i>
                  </button>
                </div>
                <div class="input-field">
                  <textarea 
                    [(ngModel)]="novaMensagem" 
                    placeholder="Digite sua mensagem..."
                    (keydown.enter)="enviarMensagem($event)"
                    class="form-control"
                    rows="1">
                  </textarea>
                </div>
                <div class="send-button">
                  <button 
                    class="btn btn-primary" 
                    (click)="enviarMensagem()"
                    [disabled]="!novaMensagem?.trim()">
                    <i class="fas fa-paper-plane"></i>
                  </button>
                </div>
              </div>
            </div>
            
          </div>
          
        </div>
      </div>

      <!-- Aba Serviços -->
      <div class="tab-pane tab-pane-servicos" [class.active]="abaAtiva === 'servicos'">

        <div class="tab-body">
          
          <!-- Sub-abas de Serviços -->
          <div class="sub-tabs-container">
            <div class="sub-tabs-visibility-filter">
              <span class="sub-tabs-visibility-filter-title">Habilitar Abas</span>
              <label class="sub-tabs-visibility-option" *ngFor="let abaServico of opcoesSubAbasServicos">
                <input
                  type="checkbox"
                  [checked]="isSubAbaServicoSelecionada(abaServico.id)"
                  (change)="onToggleSubAbaServico(abaServico.id, $any($event.target).checked)">
                <span>{{ abaServico.label }}</span>
              </label>
            </div>

            <nav class="sub-tabs-nav">
              <ul class="sub-tabs-list">
                <li
                  class="sub-tab-item"
                  *ngIf="isSubAbaServicoSelecionada('naturalizacao')"
                  [class.active]="subAbaAtiva === 'naturalizacao'"
                  (click)="selecionarSubAba('naturalizacao')">
                  <i class="fas fa-passport"></i>
                  <span>Naturalização</span>
                </li>
                <li
                  class="sub-tab-item"
                  *ngIf="isSubAbaServicoSelecionada('jud-ita')"
                  [class.active]="subAbaAtiva === 'jud-ita'"
                  (click)="selecionarSubAba('jud-ita')">
                  <i class="fas fa-gavel"></i>
                  <span>Cidadania</span>
                </li>
                <li
                  class="sub-tab-item"
                  *ngIf="isSubAbaServicoSelecionada('aire')"
                  [class.active]="subAbaAtiva === 'aire'"
                  (click)="selecionarSubAba('aire')">
                  <i class="fas fa-id-card"></i>
                  <span>AIRE</span>
                </li>
                <li
                  class="sub-tab-item"
                  *ngIf="isSubAbaServicoSelecionada('fast-it')"
                  [class.active]="subAbaAtiva === 'fast-it'"
                  (click)="selecionarSubAba('fast-it')">
                  <i class="fas fa-bolt"></i>
                  <span>Fast-It</span>
                </li>
                <li
                  class="sub-tab-item"
                  *ngIf="isSubAbaServicoSelecionada('traducao')"
                  [class.active]="subAbaAtiva === 'traducao'"
                  (click)="selecionarSubAba('traducao')">
                  <i class="fas fa-language"></i>
                  <span>Tradução</span>
                </li>
                <li
                  class="sub-tab-item"
                  *ngIf="isSubAbaServicoSelecionada('busca-documentos')"
                  [class.active]="subAbaAtiva === 'busca-documentos'"
                  (click)="selecionarSubAba('busca-documentos')">
                  <i class="fas fa-search"></i>
                  <span>Busca de Documentos</span>
                </li>
              </ul>
            </nav>

            <!-- Conteúdo das Sub-abas -->
            <div class="sub-tab-content">
              
              <!-- Sub-aba Naturalização -->
              <div class="sub-tab-pane" *ngIf="isSubAbaServicoSelecionada('naturalizacao')" [class.active]="subAbaAtiva === 'naturalizacao'">
                <div class="sub-tab-header">
                  <h3><i class="fas fa-passport"></i> Naturalização</h3>
                </div>
                <div class="sub-tab-body">
                  
                  <!-- Formulário de Naturalização -->
                  <form [formGroup]="formNaturalizacao" class="form-naturalizacao">
                    
                    <!-- Primeira linha: 3 campos -->
                    <div class="form-row three-columns">
                      <div class="form-group">
                        <label for="comuneTranscricao">Comune Transcrição</label>
                        <input type="text" id="comuneTranscricao" formControlName="comuneTranscricao" class="form-control" placeholder="Digite o comune">
                      </div>
                      <div class="form-group">
                        <label for="dadosTranscricao">Dados Transcrição</label>
                        <input type="text" id="dadosTranscricao" formControlName="dadosTranscricao" class="form-control" placeholder="Digite os dados">
                      </div>
                      <div class="form-group">
                        <label for="idStatusGeralNaturalizacao">Status do Serviço</label>
                        <select id="idStatusGeralNaturalizacao" formControlName="idStatusGeral" class="form-control">
                          <option [ngValue]="null">Selecione...</option>
                          <option *ngFor="let s of statusNaturalizacaoOpcoes" [ngValue]="s.idStatusGeral">{{ s.titulo }}</option>
                        </select>
                        <small class="text-muted" *ngIf="carregandoStatusNaturalizacao">Carregando status...</small>
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group">
                        <label for="nomeConjugeItaliana">Nome cônjuge Italiano(a)</label>
                        <input
                          type="text"
                          id="nomeConjugeItaliana"
                          formControlName="nomeConjugeItaliana"
                          class="form-control"
                          maxlength="250"
                          placeholder="Digite o nome do cônjuge italiano">
                      </div>
                    </div>
                    
                    <!-- Segunda linha: agrupador Account Ministério -->
                    <div class="form-section form-section-account-ministerio">
                      <div class="account-ministerio-card">
                        <h4 class="section-subtitle">
                          Account Ministério
                        </h4>
                        <div class="form-row two-columns">
                          <div class="form-group">
                            <label for="usuario">Usuário</label>
                            <input type="text" id="usuario" formControlName="usuario" class="form-control" placeholder="Usuário">
                          </div>
                          <div class="form-group">
                            <label for="senhaNaturalizacaoAccountMinisterio">Senha</label>
                            <div class="password-field-wrap">
                              <input
                                [type]="naturalizacaoSenhaVisivel ? 'text' : 'password'"
                                id="senhaNaturalizacaoAccountMinisterio"
                                formControlName="senha"
                                class="form-control"
                                placeholder="Senha"
                                autocomplete="off">
                              <button
                                type="button"
                                class="btn-toggle-password"
                                [attr.aria-label]="naturalizacaoSenhaVisivel ? 'Ocultar senha' : 'Mostrar senha'"
                                (click)="naturalizacaoSenhaVisivel = !naturalizacaoSenhaVisivel">
                                <i class="fas" [ngClass]="naturalizacaoSenhaVisivel ? 'fa-eye-slash' : 'fa-eye'"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Terceira linha: 2 campos -->
                    <div class="form-row two-columns">
                      <div class="form-group">
                        <label for="invioDigitale">Invio Digitale</label>
                        <input type="date" id="invioDigitale" formControlName="invioDigitale" class="form-control">
                      </div>
                      <div class="form-group">
                        <label for="accettazione">Accettazione</label>
                        <input type="date" id="accettazione" formControlName="accettazione" class="form-control">
                      </div>
                    </div>
                    
                    <!-- Quarta linha: 2 campos -->
                    <div class="form-row two-columns">
                      <div class="form-group">
                        <label for="praticaK10">Prática K10</label>
                        <input type="text" id="praticaK10" formControlName="praticaK10" class="form-control" maxlength="255" placeholder="Texto livre (até 255 caracteres)">
                      </div>
                      <div class="form-group">
                        <label for="consegnaOriginali">Consegna Originali</label>
                        <input type="date" id="consegnaOriginali" formControlName="consegnaOriginali" class="form-control">
                      </div>
                    </div>
                    
                    <!-- Quinta linha: 2 campos -->
                    <div class="form-row two-columns">
                      <div class="form-group">
                        <label for="notificaDecreto">Notifica Decreto</label>
                        <input type="date" id="notificaDecreto" formControlName="notificaDecreto" class="form-control">
                      </div>
                      <div class="form-group">
                        <label for="giuramento">Giuramento</label>
                        <input type="date" id="giuramento" formControlName="giuramento" class="form-control">
                      </div>
                    </div>
                    
                    <!-- Botões de Ação -->
                    <div class="form-actions">
                      <button type="button" class="btn btn-secondary" (click)="limparFormularioNaturalizacao()">
                        <i class="fas fa-eraser"></i> Limpar
                      </button>
                      <button type="button" class="btn btn-primary" (click)="salvarNaturalizacao()">
                        <i class="fas fa-save"></i> Salvar Naturalização
                      </button>
                    </div>
                    
                  </form>
                  
                </div>
              </div>

              <!-- Sub-aba Cidadania -->
              <div class="sub-tab-pane" *ngIf="isSubAbaServicoSelecionada('jud-ita')" [class.active]="subAbaAtiva === 'jud-ita'">
                <div class="sub-tab-header">
                  <h3><i class="fas fa-gavel"></i> Cidadania</h3>
                </div>
                <div class="sub-tab-body">
                  
                  <!-- Formulário de Jud Ita -->
                  <form [formGroup]="formJudIta" class="form-jud-ita">

                    <!-- Seletor Modalidade: Administrativo | Ministerial -->
                    <div class="form-row single-column jud-ita-modalidade-row">
                      <div class="form-group form-group--jud-ita-modalidade">
                        <label>Modalidade</label>
                        <div class="modalidade-segment" role="group" aria-label="Modalidade da cidadania">
                          <button
                            type="button"
                            class="modalidade-segment-btn"
                            [class.active]="!isJudItaModalidadeMinisterial()"
                            (click)="setJudItaModalidade('ADMINISTRATIVO')">
                            Administrativo
                          </button>
                          <button
                            type="button"
                            class="modalidade-segment-btn"
                            [class.active]="isJudItaModalidadeMinisterial()"
                            (click)="setJudItaModalidade('MINISTERIAL')">
                            Ministerial
                          </button>
                        </div>
                      </div>
                    </div>

                    <ng-container *ngIf="isJudItaModalidadeMinisterial()">
                    
                    <!-- Seção de Informações Gerais -->
                    <div class="form-section">
                      
                      <!-- Primeira linha: agrupamento Dante Causa + campos de apoio -->
                      <div class="form-row jud-ita-dante-row">
                        <div class="dante-causa-card">
                          <div class="dante-causa-fields">
                            <div class="form-group">
                              <label for="danteCausa">Dante Causa</label>
                              <input
                                type="text"
                                id="danteCausa"
                                formControlName="danteCausa"
                                class="form-control"
                                placeholder="Digite o nome completo do Dante Causa">
                            </div>
                            <div class="form-group">
                              <label for="comune">Comune *</label>
                              <input
                                type="text"
                                id="comune"
                                formControlName="comune"
                                class="form-control"
                                placeholder="Digite o nome do Comune">
                            </div>
                          </div>
                        </div>
                        <div class="form-group checkbox-group stacked">
                          <div class="checkbox-container">
                            <label class="checkbox-label">
                              <input type="checkbox" id="viaPaterna" formControlName="viaPaterna">
                              <span class="checkmark"></span>
                              Via Paterna
                            </label>
                          </div>
                          <div class="checkbox-container">
                            <label class="checkbox-label">
                              <input type="checkbox" id="viaMaterna" formControlName="viaMaterna">
                              <span class="checkmark"></span>
                              Via Materna
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Seção de Remessa -->
                    <div class="form-section">
                      
                      <!-- Segunda linha: 2 campos -->
                      <div class="form-row two-columns">
                        <div class="form-group">
                          <label for="remessaOnline">Remessa Online</label>
                          <input type="date" id="remessaOnline" formControlName="remessaOnline" class="form-control">
                        </div>
                        <div class="form-group">
                          <label for="remessaFisica">Remessa Física</label>
                          <input type="date" id="remessaFisica" formControlName="remessaFisica" class="form-control">
                        </div>
                      </div>
                    </div>
                    
                    <!-- Seção de Ajuizamento -->
                    <div class="form-section">
                      
                      <!-- Terceira linha: 3 campos -->
                      <div class="form-row three-columns">
                        <div class="form-group">
                          <label for="ajuizamento">Ajuizamento</label>
                          <input type="date" id="ajuizamento" formControlName="ajuizamento" class="form-control">
                        </div>
                        <div class="form-group">
                          <label for="tribunal">Tribunal</label>
                          <select id="tribunal" formControlName="tribunal" class="form-control">
                            <option value="">Selecione...</option>
                            <option *ngFor="let tribunal of tribunaisCidadaniaOpcoes" [value]="tribunal">{{ tribunal }}</option>
                          </select>
                        </div>
                        <div class="form-group">
                          <label for="nrg">NRG</label>
                          <input type="text" id="nrg" formControlName="nrg" class="form-control" placeholder="Digite o NRG">
                        </div>
                      </div>
                    </div>
                    
                    <!-- Seção de Audiência -->
                    <div class="form-section">
                      
                      <!-- Quarta linha: 1 campo -->
                      <div class="form-row single-column audiencia-row">
                        <div class="form-group">
                          <label for="audiencia">Audiência</label>
                          <input type="date" id="audiencia" formControlName="audiencia" class="form-control">
                        </div>
                      </div>
                    </div>
                    
                    <!-- Seção de Sentença -->
                    <div class="form-section">
                      
                      <!-- Quinta linha: Sentença + agrupador PIG -->
                      <div class="form-row three-columns-pig">
                        <div class="form-group">
                          <label for="sentenca">Sentença:</label>
                          <input type="date" id="sentenca" formControlName="sentenca" class="form-control">
                        </div>
                        <div class="pig-card">
                          <h4 class="pig-title">PIG</h4>
                          <div class="pig-card-fields">
                            <div class="form-group">
                              <label for="richiesto">Richiesto</label>
                              <input type="date" id="richiesto" formControlName="richiesto" class="form-control">
                            </div>
                            <div class="form-group">
                              <label for="ritirato">Ritirato</label>
                              <input type="date" id="ritirato" formControlName="ritirato" class="form-control">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Seção de Invio DOC ADEMP -->
                    <div class="form-section">
                      
                      <!-- Sexta linha: 2 campos -->
                      <div class="form-row two-columns">
                        <div class="form-group">
                          <label for="invioDocAdemp">Invio DOC ADEMP</label>
                          <input type="date" id="invioDocAdemp" formControlName="invioDocAdemp" class="form-control">
                        </div>
                        <div class="form-group">
                          <label for="transcritasRecebidas">Transcritas recebidas</label>
                          <input type="date" id="transcritasRecebidas" formControlName="transcritasRecebidas" class="form-control">
                        </div>
                      </div>
                    </div>
                    
                    <!-- Exibir seção Apelo (Cidadania / Jud Ita) -->
                    <div class="form-row single-column jud-ita-apelo-toggle-row">
                      <div class="form-group form-group--jud-ita-apela-toggle">
                        <label for="toggleJudItaSecaoApelo">Apelo</label>
                        <div class="toggle-container">
                          <label class="toggle-switch">
                            <input
                              type="checkbox"
                              id="toggleJudItaSecaoApelo"
                              [checked]="judItaSecaoApeloVisivel"
                              (change)="alternarJudItaToggleSecaoApelo($event)">
                            <span class="toggle-slider"></span>
                          </label>
                          <span class="toggle-label">{{ judItaSecaoApeloVisivel ? 'Sim' : 'Não' }}</span>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Seção de Apelo -->
                    <div class="form-section apelo-section" *ngIf="judItaSecaoApeloVisivel">
                      <div class="section-divider">
                        <span class="divider-text">Apelo</span>
                      </div>
                      
                      <!-- Sétima linha: 2 campos -->
                      <div class="form-row two-columns">
                        <div class="form-group">
                          <label for="apeloNotificado">Apelo Notificado</label>
                          <input type="date" id="apeloNotificado" formControlName="apeloNotificado" class="form-control">
                        </div>
                        <div class="form-group">
                          <label for="primeiraAudiencia">1º Audiência</label>
                          <input type="date" id="primeiraAudiencia" formControlName="primeiraAudiencia" class="form-control">
                        </div>
                      </div>
                      
                      <!-- Oitava linha: 2 campos -->
                      <div class="form-row two-columns">
                        <div class="form-group">
                          <label for="apeloInscrito">Apelo Inscrito</label>
                          <input type="date" id="apeloInscrito" formControlName="apeloInscrito" class="form-control">
                        </div>
                        <div class="form-group">
                          <label for="segundaAudiencia">2º Audiência</label>
                          <input type="date" id="segundaAudiencia" formControlName="segundaAudiencia" class="form-control">
                        </div>
                      </div>
                      
                      <!-- Nona linha: 2 campos (alinhados com a linha anterior) -->
                      <div class="form-row two-columns">
                        <div class="form-group">
                          <!-- Campo vazio para manter alinhamento -->
                        </div>
                        <div class="form-group">
                          <label for="sentencaApelo">Sentença Apelo</label>
                          <input type="date" id="sentencaApelo" formControlName="sentencaApelo" class="form-control">
                        </div>
                      </div>
                    </div>
                    </ng-container>

                    <ng-container *ngIf="!isJudItaModalidadeMinisterial()">
                    <div class="form-section">
                      <div class="form-row single-column">
                        <div class="form-group">
                          <label>Status</label>
                          <div class="status-adm-radio-group" role="radiogroup" aria-label="Status administrativo">
                            <label class="status-adm-radio" *ngFor="let op of statusAdministrativoOpcoes">
                              <input type="radio" formControlName="statusAdministrativo" [value]="op.valor">
                              <span>{{ op.rotulo }}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-section">
                      <div class="form-row two-columns">
                        <div class="form-group">
                          <label for="danteCausaAdm">Dante Causa</label>
                          <input
                            type="text"
                            id="danteCausaAdm"
                            formControlName="danteCausa"
                            class="form-control"
                            placeholder="Digite o nome completo do Dante Causa">
                        </div>
                        <div class="form-group">
                          <label for="comuneAdm">Comune *</label>
                          <input
                            type="text"
                            id="comuneAdm"
                            formControlName="comune"
                            class="form-control"
                            placeholder="Digite o nome do Comune">
                        </div>
                      </div>
                    </div>

                    <div class="form-section">
                      <div class="form-row three-columns">
                        <div class="form-group">
                          <label for="ag">AG</label>
                          <input type="text" inputmode="numeric" id="ag" formControlName="ag" class="form-control" placeholder="Número AG">
                        </div>
                        <div class="form-group">
                          <label for="agVfs">AG-VFS</label>
                          <input type="text" inputmode="numeric" id="agVfs" formControlName="agVfs" class="form-control" placeholder="Número AG-VFS">
                        </div>
                        <div class="form-group">
                          <label for="dataAg">Data AG/AG-VFS</label>
                          <input type="date" id="dataAg" formControlName="dataAg" class="form-control">
                        </div>
                      </div>
                    </div>

                    <div class="form-section">
                      <div class="form-row two-columns">
                        <div class="form-group">
                          <label for="dataConvocacao">Convocação</label>
                          <input type="date" id="dataConvocacao" formControlName="dataConvocacao" class="form-control">
                        </div>
                        <div class="form-group">
                          <label for="dataEntregaConsulado">Entrega Consulado</label>
                          <input type="date" id="dataEntregaConsulado" formControlName="dataEntregaConsulado" class="form-control">
                        </div>
                      </div>
                    </div>
                    </ng-container>
                    
                    <!-- Botões de Ação -->
                    <div class="form-actions">
                      <button type="button" class="btn btn-secondary" (click)="limparFormularioJudIta()">
                        <i class="fas fa-eraser"></i> Limpar
                      </button>
                      <button type="button" class="btn btn-primary" (click)="salvarJudIta($event)">
                        <i class="fas fa-save"></i> Salvar Cidadania
                      </button>
                    </div>
                    
                  </form>
                  
                </div>
              </div>

              <!-- Sub-aba AIRE -->
              <div class="sub-tab-pane" *ngIf="isSubAbaServicoSelecionada('aire')" [class.active]="subAbaAtiva === 'aire'">
                <div class="sub-tab-header">
                  <h3><i class="fas fa-id-card"></i> AIRE</h3>
                </div>
                <div class="sub-tab-body">
                  
                  <!-- Formulário de AIRE -->
                  <form [formGroup]="formAire" class="form-aire">
                    
                    <!-- Primeira linha: Serviço Pago + Consulado -->
                    <div class="form-row two-columns">
                      <div class="form-group">
                        <label for="servicoPago">Serviço Pago</label>
                        <input type="date" id="servicoPago" formControlName="servicoPago" class="form-control">
                      </div>
                      <div class="form-group">
                        <label for="consulado">Consulado</label>
                        <input type="text" id="consulado" formControlName="consulado" class="form-control" placeholder="Digite o consulado">
                      </div>
                    </div>
                    
                    <!-- Segunda linha: Status do Serviço + Comune -->
                    <div class="form-row two-columns">
                      <div class="form-group">
                        <label for="idStatusGeralAire">Status do Serviço</label>
                        <select id="idStatusGeralAire" formControlName="idStatusGeral" class="form-control">
                          <option [ngValue]="null">Selecione...</option>
                          <option *ngFor="let s of statusNaturalizacaoOpcoes" [ngValue]="s.idStatusGeral">{{ s.titulo }}</option>
                        </select>
                        <small class="text-muted" *ngIf="carregandoStatusNaturalizacao">Carregando status...</small>
                      </div>
                      <div class="form-group">
                        <label for="comune">Comune</label>
                        <input type="text" id="comune" formControlName="comune" class="form-control" placeholder="Digite o comune">
                      </div>
                    </div>
                    
                    <!-- Terceira linha: agrupador Conta Portal FAST IT -->
                    <div class="form-section">
                      <div class="form-row two-columns aire-conta-portal-row">
                        <div class="aire-conta-portal-card">
                          <h4 class="aire-conta-portal-title">Conta Portal FAST IT</h4>
                          <div class="aire-conta-portal-fields">
                            <div class="form-group">
                              <label for="usuario">Usuário</label>
                              <input type="text" id="usuario" formControlName="usuario" class="form-control" placeholder="Usuário">
                            </div>
                            <div class="form-group">
                              <label for="senhaAireContaPortal">Senha</label>
                              <div class="password-field-wrap">
                                <input
                                  [type]="aireSenhaVisivel ? 'text' : 'password'"
                                  id="senhaAireContaPortal"
                                  formControlName="senha"
                                  class="form-control"
                                  placeholder="Senha"
                                  autocomplete="off">
                                <button
                                  type="button"
                                  class="btn-toggle-password"
                                  [attr.aria-label]="aireSenhaVisivel ? 'Ocultar senha' : 'Mostrar senha'"
                                  (click)="aireSenhaVisivel = !aireSenhaVisivel">
                                  <i class="fas" [ngClass]="aireSenhaVisivel ? 'fa-eye-slash' : 'fa-eye'"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="aire-inscricoes-fields">
                          <div class="form-group">
                          <label for="inscricaoSolicitada">Inscrição Solicitada</label>
                          <input type="date" id="inscricaoSolicitada" formControlName="inscricaoSolicitada" class="form-control">
                          </div>
                          <div class="form-group">
                          <label for="inscricaoAprovada">Inscrição Aprovada</label>
                          <input type="date" id="inscricaoAprovada" formControlName="inscricaoAprovada" class="form-control">
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Botões de Ação -->
                    <div class="form-actions">
                      <button type="button" class="btn btn-secondary" (click)="limparFormularioAire()">
                        <i class="fas fa-eraser"></i> Limpar
                      </button>
                      <button type="button" class="btn btn-primary" (click)="salvarAire($event)">
                        <i class="fas fa-save"></i> Salvar AIRE
                      </button>
                    </div>
                    
                  </form>
                  
                </div>
              </div>

              <!-- Sub-aba Fast-It -->
              <div class="sub-tab-pane" *ngIf="isSubAbaServicoSelecionada('fast-it')" [class.active]="subAbaAtiva === 'fast-it'">
                <div class="sub-tab-header">
                  <h3><i class="fas fa-bolt"></i> Fast-It</h3>
                </div>
                <div class="sub-tab-body">
                  
                  <!-- Formulário de Fast-It -->
                  <form [formGroup]="formFastIt" class="form-fast-it">
                    
                    <!-- Primeira linha: 2 campos -->
                    <div class="form-row two-columns">
                      <div class="form-group">
                        <label for="servicoPago">Serviço Pago:</label>
                        <input type="date" id="servicoPago" formControlName="servicoPago" class="form-control">
                      </div>
                      <div class="form-group">
                        <label for="consulado">Consulado:</label>
                        <input type="text" id="consulado" formControlName="consulado" class="form-control" placeholder="Digite o consulado">
                      </div>
                    </div>
                    
                    <!-- Segunda linha: 2 campos -->
                    <div class="form-row two-columns">
                      <div class="form-group">
                        <label for="idStatusGeralFastIt">Status do Serviço:</label>
                        <select id="idStatusGeralFastIt" formControlName="idStatusGeral" class="form-control">
                          <option [ngValue]="null">Selecione...</option>
                          <option *ngFor="let s of statusNaturalizacaoOpcoes" [ngValue]="s.idStatusGeral">{{ s.titulo }}</option>
                        </select>
                        <small class="text-muted" *ngIf="carregandoStatusNaturalizacao">Carregando status...</small>
                      </div>
                      <div class="form-group">
                        <label for="comune">Comune:</label>
                        <input type="text" id="comune" formControlName="comune" class="form-control" placeholder="Digite o comune">
                      </div>
                    </div>
                    
                    <!-- Seção Conta Portal FAST IT -->
                    <div class="form-section">
                      <div class="form-row fast-it-conta-portal-row">
                        <div class="fast-it-conta-portal-card">
                          <h4 class="fast-it-conta-portal-title">Conta Portal FAST IT</h4>
                          <div class="fast-it-conta-portal-fields">
                            <div class="form-group">
                              <label for="usuario">Usuário</label>
                              <input type="text" id="usuario" formControlName="usuario" class="form-control" placeholder="Usuário">
                            </div>
                            <div class="form-group">
                              <label for="senhaFastItContaPortal">Senha</label>
                              <div class="password-field-wrap">
                                <input
                                  [type]="fastItSenhaVisivel ? 'text' : 'password'"
                                  id="senhaFastItContaPortal"
                                  formControlName="senha"
                                  class="form-control"
                                  placeholder="Senha"
                                  autocomplete="off">
                                <button
                                  type="button"
                                  class="btn-toggle-password"
                                  [attr.aria-label]="fastItSenhaVisivel ? 'Ocultar senha' : 'Mostrar senha'"
                                  (click)="fastItSenhaVisivel = !fastItSenhaVisivel">
                                  <i class="fas" [ngClass]="fastItSenhaVisivel ? 'fa-eye-slash' : 'fa-eye'"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Botões de Ação -->
                    <div class="form-actions">
                      <button type="button" class="btn btn-secondary" (click)="limparFormularioFastIt()">
                        <i class="fas fa-eraser"></i> Limpar
                      </button>
                      <button type="button" class="btn btn-primary" (click)="salvarFastIt($event)">
                        <i class="fas fa-save"></i> Salvar Fast-It
                      </button>
                    </div>
                    
                  </form>
                  
                </div>
              </div>

              <!-- Sub-aba Tradução -->
              <div class="sub-tab-pane" *ngIf="isSubAbaServicoSelecionada('traducao')" [class.active]="subAbaAtiva === 'traducao'">
                <div class="sub-tab-header">
                  <h3><i class="fas fa-language"></i> Tradução</h3>
                </div>
                <div class="sub-tab-body">
                  
                  <!-- Formulário de Tradução -->
                  <form [formGroup]="formTraducao" class="form-traducao">
                    
                    <!-- Primeira linha: 2 campos -->
                    <div class="form-row two-columns">
                      <div class="form-group">
                        <label for="dataDemanda">Data da Demanda:</label>
                        <input type="date" id="dataDemanda" formControlName="dataDemanda" class="form-control">
                      </div>
                      <div class="form-group">
                        <label for="prazoLimite">Prazo Limite:</label>
                        <input type="date" id="prazoLimite" formControlName="prazoLimite" class="form-control">
                      </div>
                    </div>
                    
                    <!-- Segunda linha: status -->
                    <div class="form-row two-columns">
                      <div class="form-group">
                        <label for="idStatusGeralTraducao">Status do Serviço:</label>
                        <select id="idStatusGeralTraducao" formControlName="idStatusGeral" class="form-control">
                          <option [ngValue]="null">Selecione...</option>
                          <option *ngFor="let s of statusTraducaoOpcoes" [ngValue]="s.idStatusGeral">{{ s.titulo }}</option>
                        </select>
                        <small class="text-muted" *ngIf="carregandoStatusTraducao">Carregando status...</small>
                      </div>
                    </div>

                    <!-- Necessidade de Dobradura -->
                    <div class="form-row traducao-toggles-row">
                      <div class="form-group form-group--toggle-sim-nao">
                        <label for="necessidadeDobraduraToggle">Necessidade de Dobradura:</label>
                        <div class="toggle-container">
                          <label class="toggle-switch">
                            <input type="checkbox" id="necessidadeDobraduraToggle" formControlName="necessidadeDobradura">
                            <span class="toggle-slider"></span>
                          </label>
                          <span class="toggle-label">{{ formTraducao.get('necessidadeDobradura')?.value ? 'Sim' : 'Não' }}</span>
                        </div>
                      </div>
                    </div>
                    
                    <div class="documentos-table-toolbar">
                      <button type="button" class="btn btn-sm btn-outline-primary" (click)="abrirModalTipoDocumentoTraducao()">
                        <i class="fas fa-file-medical"></i> Adicionar documento
                      </button>
                      <small class="text-muted" *ngIf="carregandoTiposDocumentoTraducao">Carregando tipos de documento...</small>
                    </div>
                    <div class="documentos-table-container">
                      <table class="documentos-table documentos-table--editavel">
                        <thead>
                          <tr>
                            <th class="col-documento">Documento a ser traduzido</th>
                            <th class="col-titular">Titular</th>
                            <th class="col-tradutor">Tradutor</th>
                            <th class="col-revisor">Revisor</th>
                            <th class="col-apostilar-documento">Apostilar Documento</th>
                            <th class="col-apostilar-traducao">Apostilar Tradução</th>
                            <th class="col-acoes"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let linha of traducaoItens; let i = index">
                            <td class="col-documento">
                              <select class="form-control form-control-sm" [(ngModel)]="linha.idTipoDocumento" [ngModelOptions]="{ standalone: true }">
                                <option [ngValue]="null">Selecione...</option>
                                <option *ngFor="let t of tiposDocumentoTraducaoOpcoes" [ngValue]="t.idTipoDocumento">{{ t.titulo }}</option>
                              </select>
                            </td>
                            <td class="col-titular">
                              <input type="text" class="form-control form-control-sm" [(ngModel)]="linha.titular" [ngModelOptions]="{ standalone: true }" placeholder="Titular">
                            </td>
                            <td class="col-tradutor">
                              <input type="text" class="form-control form-control-sm" [(ngModel)]="linha.tradutor" [ngModelOptions]="{ standalone: true }" maxlength="255" placeholder="Tradutor">
                            </td>
                            <td class="col-revisor">
                              <input type="text" class="form-control form-control-sm" [(ngModel)]="linha.revisor" [ngModelOptions]="{ standalone: true }" maxlength="255" placeholder="Revisor">
                            </td>
                            <td class="col-apostilar-documento">
                              <div class="documentos-table-toggle">
                                <label class="toggle-switch">
                                  <input type="checkbox" [(ngModel)]="linha.apostilarDocumento" [ngModelOptions]="{ standalone: true }">
                                  <span class="toggle-slider"></span>
                                </label>
                                <span class="toggle-label">{{ linha.apostilarDocumento ? 'Sim' : 'Não' }}</span>
                              </div>
                            </td>
                            <td class="col-apostilar-traducao">
                              <div class="documentos-table-toggle">
                                <label class="toggle-switch">
                                  <input type="checkbox" [(ngModel)]="linha.apostilarTraducao" [ngModelOptions]="{ standalone: true }">
                                  <span class="toggle-slider"></span>
                                </label>
                                <span class="toggle-label">{{ linha.apostilarTraducao ? 'Sim' : 'Não' }}</span>
                              </div>
                            </td>
                            <td class="col-acoes">
                              <button type="button" class="btn btn-link btn-sm text-danger p-0" title="Remover linha" (click)="removerLinhaTraducao(i)">
                                <i class="fas fa-trash-alt"></i>
                              </button>
                            </td>
                          </tr>
                          <tr *ngIf="traducaoItens.length === 0">
                            <td colspan="7" class="documentos-table-empty">
                              Nenhum documento adicionado. Use <strong>Adicionar linha</strong> abaixo da tabela.
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- Botões de Ação -->
                    <div class="form-actions form-actions-busca-brasil">
                      <button type="button" class="btn btn-sm btn-outline-primary btn-adicionar-linha-busca" (click)="adicionarLinhaTraducao()">
                        <i class="fas fa-plus"></i> Adicionar linha
                      </button>
                      <div class="form-actions-grupo-direita">
                        <button type="button" class="btn btn-secondary" (click)="limparFormularioTraducao()">
                          <i class="fas fa-eraser"></i> Limpar
                        </button>
                        <button type="button" class="btn btn-primary" (click)="salvarTraducao($event)">
                          <i class="fas fa-save"></i> Salvar Tradução
                        </button>
                      </div>
                    </div>
                    
                  </form>
                  
                </div>
              </div>

              <!-- Sub-aba Busca de Documentos -->
              <div class="sub-tab-pane" *ngIf="isSubAbaServicoSelecionada('busca-documentos')" [class.active]="subAbaAtiva === 'busca-documentos'">
                <div class="sub-tab-header">
                  <h3><i class="fas fa-search"></i> Busca de Documentos</h3>
                </div>
                <div class="sub-tab-body">
                  
                  <!-- Sub-abas para Busca de Documentos -->
                  <div class="sub-tabs-container">
                    <div class="sub-tabs-nav">
                      <ul class="sub-tabs-list">
                        <li class="sub-tab-item" [class.active]="subAbaBuscaAtiva === 'brasil'">
                          <a href="#" (click)="selecionarSubAbaBusca('brasil', $event)">
                            <i class="fas fa-flag"></i> Brasil
                          </a>
                        </li>
                        <li class="sub-tab-item" [class.active]="subAbaBuscaAtiva === 'italia'">
                          <a href="#" (click)="selecionarSubAbaBusca('italia', $event)">
                            <i class="fas fa-flag"></i> Itália
                          </a>
                        </li>
                      </ul>
                    </div>
                    
                    <div class="sub-tab-content">
                      
                      <!-- Sub-aba Brasil -->
                      <div class="sub-tab-pane" [class.active]="subAbaBuscaAtiva === 'brasil'">
                        <div class="sub-tab-header">
                          <h4><i class="fas fa-flag"></i> Busca de Documentos - Brasil</h4>
                        </div>
                        <div class="sub-tab-body">
                          
                          <!-- Formulário de Busca de Documentos - Brasil -->
                          <form [formGroup]="formBuscaBrasil" class="form-busca-brasil">
                            
                            <!-- Seção Superior: 2 campos -->
                            <div class="form-row two-columns">
                              <div class="form-group">
                                <label for="buscaBrasilDataDemanda">Data da Demanda:</label>
                                <input type="date" id="buscaBrasilDataDemanda" formControlName="dataDemanda" class="form-control">
                              </div>
                              <div class="form-group">
                                <label for="idStatusGeralBuscaBrasil">Status geral do pedido:</label>
                                <select
                                  id="idStatusGeralBuscaBrasil"
                                  formControlName="idStatusGeral"
                                  class="form-control"
                                  [compareWith]="compareStatusGeralId">
                                  <option [ngValue]="null">Selecione...</option>
                                  <option *ngFor="let s of statusBuscaBrasilOpcoes" [ngValue]="s.idStatusGeral">{{ s.titulo }}</option>
                                </select>
                                <small class="text-muted" *ngIf="carregandoStatusBuscaBrasil">Carregando status...</small>
                              </div>
                            </div>
                            
                            <!-- Tabela de Documentos -->
                            <div class="documentos-table-toolbar">
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-primary"
                                (click)="abrirModalTipoDocumentoBuscaBrasil()">
                                <i class="fas fa-file-medical"></i> Adicionar documento
                              </button>
                              <small class="text-muted" *ngIf="carregandoTiposDocumentoBuscaBrasil">
                                Carregando tipos de documento...
                              </small>
                            </div>
                            <div class="documentos-table-container">
                              <table class="documentos-table documentos-table--editavel">
                                <thead>
                                  <tr>
                                    <th class="col-documento">Documento a ser providenciado</th>
                                    <th class="col-titular">Titular</th>
                                    <th class="col-cidade">Cidade</th>
                                    <th class="col-estado">Estado</th>
                                    <th class="col-quantidade">Qtdade</th>
                                    <th class="col-solicitado">Solicitado</th>
                                    <th class="col-recebido">Recebido</th>
                                    <th class="col-acoes"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let linha of buscaBrasilItens; let i = index">
                                    <td class="col-documento">
                                      <select
                                        class="form-control form-control-sm"
                                        [(ngModel)]="linha.idTipoDocumento"
                                        [ngModelOptions]="{ standalone: true }">
                                        <option [ngValue]="null">Selecione...</option>
                                        <option
                                          *ngFor="let t of tiposDocumentoBuscaBrasilOpcoes"
                                          [ngValue]="t.idTipoDocumento">
                                          {{ t.titulo }}
                                        </option>
                                      </select>
                                    </td>
                                    <td class="col-titular">
                                      <input
                                        type="text"
                                        class="form-control form-control-sm"
                                        [(ngModel)]="linha.titular"
                                        [ngModelOptions]="{ standalone: true }"
                                        placeholder="Titular">
                                    </td>
                                    <td class="col-cidade">
                                      <input
                                        type="text"
                                        class="form-control form-control-sm"
                                        [(ngModel)]="linha.cidade"
                                        [ngModelOptions]="{ standalone: true }"
                                        placeholder="Cidade">
                                    </td>
                                    <td class="col-estado">
                                      <input
                                        type="text"
                                        class="form-control form-control-sm"
                                        [(ngModel)]="linha.estado"
                                        [ngModelOptions]="{ standalone: true }"
                                        maxlength="10"
                                        placeholder="UF">
                                    </td>
                                    <td class="col-quantidade">
                                      <input
                                        type="number"
                                        class="form-control form-control-sm"
                                        [(ngModel)]="linha.quantidade"
                                        [ngModelOptions]="{ standalone: true }"
                                        min="1"
                                        step="1">
                                    </td>
                                    <td class="col-solicitado">
                                      <input
                                        type="date"
                                        class="form-control form-control-sm"
                                        [(ngModel)]="linha.solicitado"
                                        [ngModelOptions]="{ standalone: true }">
                                    </td>
                                    <td class="col-recebido">
                                      <input
                                        type="date"
                                        class="form-control form-control-sm"
                                        [(ngModel)]="linha.recebido"
                                        [ngModelOptions]="{ standalone: true }">
                                    </td>
                                    <td class="col-acoes">
                                      <button
                                        type="button"
                                        class="btn btn-link btn-sm text-danger p-0"
                                        title="Remover linha"
                                        (click)="removerLinhaBuscaBrasil(i)">
                                        <i class="fas fa-trash-alt"></i>
                                      </button>
                                    </td>
                                  </tr>
                                  <tr *ngIf="buscaBrasilItens.length === 0">
                                    <td colspan="8" class="documentos-table-empty">
                                      Nenhum documento adicionado. Use <strong>Adicionar linha</strong> abaixo da tabela.
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            
                            <!-- Botões de Ação -->
                            <div class="form-actions form-actions-busca-brasil">
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-primary btn-adicionar-linha-busca"
                                (click)="adicionarLinhaBuscaBrasil()">
                                <i class="fas fa-plus"></i> Adicionar linha
                              </button>
                              <div class="form-actions-grupo-direita">
                                <button type="button" class="btn btn-secondary" (click)="limparFormularioBuscaBrasil()">
                                  <i class="fas fa-eraser"></i> Limpar
                                </button>
                                <button type="button" class="btn btn-primary" (click)="salvarBuscaBrasil($event)">
                                  <i class="fas fa-save"></i> Salvar Busca Brasil
                                </button>
                              </div>
                            </div>
                            
                          </form>
                          
                        </div>
                      </div>
                      
                      <!-- Sub-aba Itália -->
                      <div class="sub-tab-pane" [class.active]="subAbaBuscaAtiva === 'italia'">
                        <div class="sub-tab-header">
                          <h4><i class="fas fa-flag"></i> Busca de Documentos - Itália</h4>
                        </div>
                        <div class="sub-tab-body">
                          
                          <!-- Formulário de Busca de Documentos - Itália -->
                          <form [formGroup]="formBuscaItalia" class="form-busca-italia">
                            
                            <!-- Primeira linha: 2 campos -->
                            <div class="form-row two-columns">
                              <div class="form-group">
                                <label for="buscaItaliaDataDemanda">Data da Demanda:</label>
                                <input type="date" id="buscaItaliaDataDemanda" formControlName="dataDemanda" class="form-control">
                              </div>
                              <div class="form-group">
                                <label for="idStatusGeralBuscaItalia">Status geral do pedido:</label>
                                <select
                                  id="idStatusGeralBuscaItalia"
                                  formControlName="idStatusGeral"
                                  class="form-control"
                                  [compareWith]="compareStatusGeralId">
                                  <option [ngValue]="null">Selecione...</option>
                                  <option *ngFor="let s of statusBuscaItaliaOpcoes" [ngValue]="s.idStatusGeral">{{ s.titulo }}</option>
                                </select>
                                <small class="text-muted" *ngIf="carregandoStatusBuscaItalia">Carregando status...</small>
                              </div>
                            </div>
                            
                            <div class="documentos-table-toolbar">
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-primary"
                                (click)="abrirModalTipoDocumentoBuscaItalia()">
                                <i class="fas fa-file-medical"></i> Adicionar documento
                              </button>
                              <small class="text-muted" *ngIf="carregandoTiposDocumentoBuscaItalia">
                                Carregando tipos de documento...
                              </small>
                            </div>
                            
                            <div class="documentos-table-container">
                              <table class="documentos-table documentos-table--editavel">
                                <thead>
                                  <tr>
                                    <th class="col-documento">Documento a ser providenciado</th>
                                    <th class="col-titular">Titular</th>
                                    <th class="col-cidade">Cidade</th>
                                    <th class="col-quantidade">Qtdade</th>
                                    <th class="col-solicitado">Solicitado</th>
                                    <th class="col-recebido">Recebido</th>
                                    <th class="col-acoes"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let linha of buscaItaliaItens; let i = index">
                                    <td class="col-documento">
                                      <select class="form-control form-control-sm" [(ngModel)]="linha.idTipoDocumento" [ngModelOptions]="{ standalone: true }">
                                        <option [ngValue]="null">Selecione...</option>
                                        <option *ngFor="let t of tiposDocumentoBuscaItaliaOpcoes" [ngValue]="t.idTipoDocumento">{{ t.titulo }}</option>
                                      </select>
                                    </td>
                                    <td class="col-titular">
                                      <input type="text" class="form-control form-control-sm" [(ngModel)]="linha.titular" [ngModelOptions]="{ standalone: true }" placeholder="Titular">
                                    </td>
                                    <td class="col-cidade">
                                      <input type="text" class="form-control form-control-sm" [(ngModel)]="linha.cidade" [ngModelOptions]="{ standalone: true }" placeholder="Cidade">
                                    </td>
                                    <td class="col-quantidade">
                                      <input type="number" class="form-control form-control-sm" [(ngModel)]="linha.quantidade" [ngModelOptions]="{ standalone: true }" min="1" step="1">
                                    </td>
                                    <td class="col-solicitado">
                                      <input type="date" class="form-control form-control-sm" [(ngModel)]="linha.solicitado" [ngModelOptions]="{ standalone: true }">
                                    </td>
                                    <td class="col-recebido">
                                      <input type="date" class="form-control form-control-sm" [(ngModel)]="linha.recebido" [ngModelOptions]="{ standalone: true }">
                                    </td>
                                    <td class="col-acoes">
                                      <button type="button" class="btn btn-link btn-sm text-danger p-0" title="Remover linha" (click)="removerLinhaBuscaItalia(i)">
                                        <i class="fas fa-trash-alt"></i>
                                      </button>
                                    </td>
                                  </tr>
                                  <tr *ngIf="buscaItaliaItens.length === 0">
                                    <td colspan="7" class="documentos-table-empty">
                                      Nenhum documento adicionado. Use <strong>Adicionar linha</strong> abaixo da tabela.
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>

                            <div class="form-actions form-actions-busca-brasil">
                              <button type="button" class="btn btn-sm btn-outline-primary btn-adicionar-linha-busca" (click)="adicionarLinhaBuscaItalia()">
                                <i class="fas fa-plus"></i> Adicionar linha
                              </button>
                              <div class="form-actions-grupo-direita">
                                <button type="button" class="btn btn-secondary" (click)="limparFormularioBuscaItalia()">
                                  <i class="fas fa-eraser"></i> Limpar
                                </button>
                                <button type="button" class="btn btn-primary" (click)="salvarBuscaItalia($event)">
                                  <i class="fas fa-save"></i> Salvar Busca Itália
                                </button>
                              </div>
                            </div>
                            
                          </form>
                          
                        </div>
                      </div>
                      

                    </div>
                  </div>
                  
                </div>
              </div>

            </div>
          </div>
          
        </div>
      </div>

      <!-- Aba Documento -->
      <div class="tab-pane" [class.active]="abaAtiva === 'documento'">
        <div class="tab-header">
          <h2><i class="fas fa-file-alt"></i> Documentos</h2>
        </div>
        <div class="tab-body">
          <div *ngIf="carregandoTiposArquivoDocumentos" class="alert alert-info mb-3">
            <i class="fas fa-spinner fa-spin"></i> Carregando tipos de documento...
          </div>

          <div *ngIf="!carregandoTiposArquivoDocumentos && tiposArquivoDocumentos.length === 0" class="alert alert-warning mb-3">
            Nenhum tipo de arquivo cadastrado na tabela <strong>TIPO_ARQUIVO</strong> ou não foi possível carregar a lista.
          </div>

          <ng-container *ngIf="!carregandoTiposArquivoDocumentos && tiposArquivoDocumentos.length > 0">
            <div class="form-group mb-3" style="max-width: 420px;">
              <label for="selectTipoArquivoDocumento">Tipo de arquivo (TIPO_ARQUIVO)</label>
              <select
                id="selectTipoArquivoDocumento"
                class="form-control"
                [ngModel]="abaTipoArquivoAtivaId"
                (ngModelChange)="selecionarAbaTipoArquivo($event)"
              >
                <option *ngFor="let t of tiposArquivoDocumentos" [ngValue]="t.idTipoArquivo">
                  {{ t.descricao }}
                </option>
              </select>
            </div>

            <div class="sub-tabs-container sub-tabs-container--documentos-tipos">
              <nav class="sub-tabs-nav">
                <ul class="sub-tabs-list">
                  <li
                    *ngFor="let t of tiposArquivoDocumentos"
                    class="sub-tab-item"
                    [class.active]="abaTipoArquivoAtivaId === t.idTipoArquivo"
                    (click)="selecionarAbaTipoArquivo(t.idTipoArquivo)"
                  >
                    <i class="fas fa-file-alt"></i>
                    <span>{{ t.descricao }}</span>
                  </li>
                </ul>
              </nav>

              <div class="sub-tab-content">
                <div
                  *ngFor="let t of tiposArquivoDocumentos"
                  class="sub-tab-pane"
                  [class.active]="abaTipoArquivoAtivaId === t.idTipoArquivo"
                >
                  <div class="sub-tab-header">
                    <h3><i class="fas fa-folder-open"></i> {{ t.descricao }}</h3>
                  </div>
                  <div class="sub-tab-body">
                    <p class="text-muted mb-0">
                      Conteúdo por tipo de documento (<strong>{{ t.descricao }}</strong> — id {{ t.idTipoArquivo }}).
                      Aqui você pode incluir upload, histórico ou checklist conforme a regra de negócio.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Aba Árvore -->
      <div class="tab-pane" [class.active]="abaAtiva === 'arvore'">
        <div class="tab-header">
          <h2><i class="fas fa-tree"></i> Árvore Genealógica</h2>
        </div>
        <div class="tab-body">
          <p>Conteúdo da aba Árvore será implementado aqui.</p>
        </div>
      </div>

      <!-- Aba Orçamentos -->
      <div class="tab-pane" [class.active]="abaAtiva === 'orcamentos'">
        <div class="tab-header">
          <h2><i class="fas fa-dollar-sign"></i> Orçamentos</h2>
        </div>
        <div class="tab-body">
          <ng-template #clienteSemIdOrcamento>
            <div class="alert alert-warning">
              Salve o cliente primeiro para habilitar os orçamentos.
            </div>
          </ng-template>

          <div *ngIf="idClienteOrcamentoAtual > 0; else clienteSemIdOrcamento">


            <div class="orcamento-layout">
              <div class="orcamento-card">
                <div class="orcamento-card-title orcamento-card-title-with-action">
                  <span>Orçamentos existentes</span>
                  <button type="button" class="btn btn-primary btn-orcamento-acao" (click)="abrirModalCadastroOrcamento()">
                    <i class="fas fa-plus"></i> Novo orçamento
                  </button>
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label>Buscar por título</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroTituloOrcamentoExistente" name="filtroTituloOrcamentoExistente" placeholder="Digite parte do título">
                  </div>
                </div>

                <div class="form-actions orcamento-acoes" style="margin-top: 0; border-top: 0; padding-top: 0;">
                  <button type="button" class="btn btn-primary btn-orcamento-acao" (click)="buscarOrcamentosConsulta()">
                    <i class="fas fa-search"></i> Atualizar lista
                  </button>
                </div>

                <div class="table-responsive orcamento-table-wrap">
                  <table class="table table-striped table-bordered orcamento-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Título</th>
                        <th>Data</th>
                        <th>Observação</th>
                        <th>Exibir p/ cliente</th>
                        <th>Aprovado</th>
                        <th>Financeiro gerado</th>
                        <th style="min-width: 300px;">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngIf="carregandoOrcamento">
                        <td colspan="8">Carregando...</td>
                      </tr>
                      <tr *ngFor="let item of orcamentosConsultaFiltrados">
                        <td>{{ item.idOrcamento }}</td>
                        <td>{{ item.titulo }}</td>
                        <td>{{ formatDataHoraMin(item.data) }}</td>
                        <td>{{ item.observacao }}</td>
                        <td>
                          <span class="orcamento-status" [class.is-yes]="item.clienteVer" [class.is-no]="!item.clienteVer">
                            {{ item.clienteVer ? 'Sim' : 'Não' }}
                          </span>
                        </td>
                        <td>
                          <span class="orcamento-status" [class.is-yes]="item.orcamentoAprovado" [class.is-no]="!item.orcamentoAprovado">
                            {{ item.orcamentoAprovado ? 'Sim' : 'Não' }}
                          </span>
                        </td>
                        <td>
                          <span class="orcamento-status" [class.is-yes]="item.financeiroGerado" [class.is-no]="!item.financeiroGerado">
                            {{ item.financeiroGerado ? 'Sim' : 'Não' }}
                          </span>
                        </td>
                        <td class="orcamento-acoes-celula">
                            <button type="button" class="btn btn-warning btn-sm btn-orcamento-inline" (click)="editarOrcamentoConsulta(item)">
                              <i class="fas fa-edit"></i> Editar
                            </button>
                          <button type="button" class="btn btn-info btn-sm btn-orcamento-inline" (click)="visualizarOrcamentoConsulta(item)">
                            <i class="fas fa-eye"></i> Visualizar
                          </button>
                          <button type="button" class="btn btn-secondary btn-sm btn-orcamento-inline" (click)="imprimirOrcamentoConsulta(item)">
                            <i class="fas fa-print"></i> Imprimir
                          </button>
                          <button type="button" class="btn btn-outline-secondary btn-sm btn-orcamento-inline" (click)="imprimirOrcamentoConsultaDetalhe(item)">
                            <i class="fas fa-print"></i> Detalhado
                          </button>
                        </td>
                      </tr>
                      <tr *ngIf="!carregandoOrcamento && orcamentosConsultaFiltrados.length === 0">
                        <td colspan="8">Nenhum orçamento encontrado.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="modalCadastroOrcamentoAberto" class="modal-orcamento-overlay">
            <div class="modal-orcamento-box">
              <div class="modal-orcamento-header">
                <h4>
                  <i class="fas fa-file-invoice-dollar"></i>
                  {{ modoVisualizacaoOrcamento ? 'Visualizar orçamento' : 'Cadastro de orçamento' }}
                </h4>
                <button type="button" class="btn btn-light btn-sm" (click)="fecharModalCadastroOrcamento()">
                  <i class="fas fa-times"></i>
                </button>
              </div>

              <div *ngIf="carregandoDetalheOrcamento" class="alert alert-info">
                Carregando dados do orçamento...
              </div>

              <div class="orcamento-layout" *ngIf="!carregandoDetalheOrcamento">
                <div class="orcamento-card">
                  <div class="orcamento-card-title">Cabeçalho</div>
                  <div class="form-row two-columns">
                    <div class="form-group">
                      <label>Selecionar Atendimento</label>
                      <select class="form-control" [(ngModel)]="idConsultaOrcamentoSelecionada" name="idConsultaOrcamentoSelecionada" [disabled]="modoVisualizacaoOrcamento">
                        <option [ngValue]="0">Selecione...</option>
                        <option *ngFor="let consulta of consultasOrcamento" [ngValue]="consulta.idConsulta">
                          {{ consulta.descricao }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label>Título*</label>
                      <input type="text" class="form-control" [(ngModel)]="tituloOrcamento" name="tituloOrcamento" placeholder="Título do orçamento" [disabled]="modoVisualizacaoOrcamento">
                    </div>
                  </div>

                  <div class="form-row two-columns two-columns-orcamento-valores">
                    <div class="form-group">
                      <label>Desconto</label>
                      <input type="number" class="form-control" [(ngModel)]="descontoOrcamento" name="descontoOrcamento" min="0" step="0.01" [disabled]="modoVisualizacaoOrcamento">
                    </div>
                    <div class="form-group">
                      <label>Acréscimo</label>
                      <input type="number" class="form-control" [(ngModel)]="acrescimoOrcamento" name="acrescimoOrcamento" min="0" step="0.01" [disabled]="modoVisualizacaoOrcamento">
                    </div>
                  </div>

                  <div class="form-row single-column">
                    <div class="form-group">
                      <label>Observação</label>
                      <textarea rows="3" class="form-control" [(ngModel)]="observacaoGeralOrcamento" name="observacaoGeralOrcamento" [disabled]="modoVisualizacaoOrcamento"></textarea>
                    </div>
                  </div>

                  <div class="form-row single-column">
                    <div class="form-group">
                      <label>Observação impressão</label>
                      <div *ngIf="!modoVisualizacaoOrcamento; else observacaoImpressaoSomenteLeitura">
                        <div class="orcamento-observacao-toolbar">
                          <button type="button" class="btn btn-toolbar-mini" title="Negrito" (click)="executarComandoObservacaoImpressao('bold')">
                            <i class="fas fa-bold"></i>
                          </button>
                          <button type="button" class="btn btn-toolbar-mini" title="Itálico" (click)="executarComandoObservacaoImpressao('italic')">
                            <i class="fas fa-italic"></i>
                          </button>
                          <button type="button" class="btn btn-toolbar-mini" title="Sublinhado" (click)="executarComandoObservacaoImpressao('underline')">
                            <i class="fas fa-underline"></i>
                          </button>
                          <span class="toolbar-mini-sep"></span>
                          <button type="button" class="btn btn-toolbar-mini" title="Lista com marcadores" (click)="executarComandoObservacaoImpressao('insertUnorderedList')">
                            <i class="fas fa-list-ul"></i>
                          </button>
                          <button type="button" class="btn btn-toolbar-mini" title="Lista numerada" (click)="executarComandoObservacaoImpressao('insertOrderedList')">
                            <i class="fas fa-list-ol"></i>
                          </button>
                          <span class="toolbar-mini-sep"></span>
                          <button type="button" class="btn btn-toolbar-mini" title="Alinhar à esquerda" (click)="executarComandoObservacaoImpressao('justifyLeft')">
                            <i class="fas fa-align-left"></i>
                          </button>
                          <button type="button" class="btn btn-toolbar-mini" title="Centralizar" (click)="executarComandoObservacaoImpressao('justifyCenter')">
                            <i class="fas fa-align-center"></i>
                          </button>
                          <button type="button" class="btn btn-toolbar-mini" title="Alinhar à direita" (click)="executarComandoObservacaoImpressao('justifyRight')">
                            <i class="fas fa-align-right"></i>
                          </button>
                          <span class="toolbar-mini-sep"></span>
                          <button type="button" class="btn btn-toolbar-mini" title="Desfazer" (click)="executarComandoObservacaoImpressao('undo')">
                            <i class="fas fa-undo"></i>
                          </button>
                          <button type="button" class="btn btn-toolbar-mini" title="Refazer" (click)="executarComandoObservacaoImpressao('redo')">
                            <i class="fas fa-redo"></i>
                          </button>
                        </div>
                        <div
                          #observacaoImpressaoEditor
                          class="orcamento-observacao-impressao-editor"
                          contenteditable="true"
                          (input)="onObservacaoImpressaoInput($event)"
                          (paste)="onObservacaoImpressaoPaste($event)"
                        ></div>
                      </div>
                      <ng-template #observacaoImpressaoSomenteLeitura>
                        <div
                          class="orcamento-observacao-impressao-readonly"
                          [innerHTML]="observacaoImpressaoOrcamento || '<p>-</p>'"
                        ></div>
                      </ng-template>
                    </div>
                  </div>

                  <div class="form-row two-columns">
                    <div class="form-group">
                      <label>Exibir para cliente</label>
                      <div class="orcamento-switch">
                        <label class="orcamento-switch-control">
                          <input
                            type="checkbox"
                            name="exibirParaCliente"
                            [(ngModel)]="exibirParaCliente"
                            [disabled]="modoVisualizacaoOrcamento"
                          />
                          <span class="orcamento-switch-slider"></span>
                        </label>
                        <div class="orcamento-switch-text">
                          {{ exibirParaCliente ? 'Sim' : 'Não' }}
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label>Orçamento aprovado</label>
                      <div class="orcamento-switch">
                        <label class="orcamento-switch-control">
                          <input
                            type="checkbox"
                            name="orcamentoAprovado"
                            [(ngModel)]="orcamentoAprovado"
                            [disabled]="modoVisualizacaoOrcamento"
                          />
                          <span class="orcamento-switch-slider"></span>
                        </label>
                        <div class="orcamento-switch-text">
                          {{ orcamentoAprovado ? 'Sim' : 'Não' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="orcamento-card">
                  <div class="orcamento-card-title">Itens do orçamento</div>
                  <div *ngIf="isEdicaoItensOrcamentoBloqueada()" class="alert alert-warning mb-2">
                    Financeiro gerado: apenas os campos do cabeçalho podem ser editados.
                  </div>
                  <div class="form-row two-columns orcamento-toolbar-row">
                    <div class="form-group">
                      <label>Adicionar Microserviço*</label>
                      <select class="form-control" [(ngModel)]="idTabelaPrecoSelecionada" name="idTabelaPrecoSelecionada" [disabled]="modoVisualizacaoOrcamento || isEdicaoItensOrcamentoBloqueada()">
                        <option [ngValue]="0">Selecione...</option>
                        <option *ngFor="let micro of microservicosLookup" [ngValue]="micro.idTabelaFin">
                          {{ micro.itemMicroservico }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group d-flex align-items-end">
                      <button type="button" class="btn btn-primary btn-orcamento-acao" (click)="adicionarMicroservicoSelecionado()" [disabled]="modoVisualizacaoOrcamento || isEdicaoItensOrcamentoBloqueada()">
                        <i class="fas fa-plus"></i> Adicionar
                      </button>
                    </div>
                  </div>

                  <div class="table-responsive orcamento-table-wrap">
                    <table class="table table-striped table-bordered orcamento-table">
                      <thead>
                        <tr>
                          <th></th>
                          <th>id</th>
                          <th>Item</th>
                          <th>Descrição</th>
                          <th>Parceiro</th>
                          <th>Qtd</th>
                          <th>Valor</th>
                          <th></th>
                          <th>Observação</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of orcamentoItensGrid; let i = index">
                          <td><input type="checkbox" [(ngModel)]="item.selecionado" name="orcSel{{ i }}" [disabled]="modoVisualizacaoOrcamento || isEdicaoItensOrcamentoBloqueada()"></td>
                          <td>{{ item.idTabelaFin }}</td>
                          <td>{{ item.item }}</td>
                          <td>{{ item.descricao }}</td>
                          <td>{{ item.parceiro }}</td>
                          <td class="orcamento-qtd-col">
                            <input
                              type="number"
                              class="form-control"
                              min="1"
                              [(ngModel)]="item.quantidade"
                              name="orcQtd{{ i }}"
                              (change)="onQuantidadeOrcamentoChange(item)"
                              [disabled]="modoVisualizacaoOrcamento || isEdicaoItensOrcamentoBloqueada()"
                            >
                          </td>
                          <td>{{ formatMoneyBRL(item.valor) }}</td>
                          <td>
                            <button type="button" class="btn btn-success btn-sm" (click)="abrirModalObservacao(i)" [disabled]="modoVisualizacaoOrcamento || isEdicaoItensOrcamentoBloqueada()">+</button>
                          </td>
                          <td class="orcamento-observacao-col">{{ item.observacao }}</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="5"></td>
                          <td><b>Total</b></td>
                          <td><b>{{ formatMoneyBRL(totalOrcamentoGrid) }}</b></td>
                          <td colspan="2"></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>

                  <div class="form-actions orcamento-acoes">
                    <div class="orcamento-acoes-esquerda">
                      <div *ngIf="financeiroGeradoOrcamento" class="orcamento-financeiro-status">
                        Financeiro já gerado
                      </div>
                      <button
                        *ngIf="!modoVisualizacaoOrcamento && idOrcamentoEdicao > 0"
                        type="button"
                        class="btn btn-info btn-orcamento-acao"
                        (click)="gerarFinanceiroOrcamentoFake()"
                        [disabled]="financeiroGeradoOrcamento"
                      >
                        <i class="fas fa-money-bill-wave"></i> Gerar financeiro
                      </button>
                    </div>
                    <div class="orcamento-acoes-direita">
                      <button type="button" class="btn btn-danger btn-orcamento-acao" (click)="removerItensSelecionadosOrcamento()" [disabled]="modoVisualizacaoOrcamento || isEdicaoItensOrcamentoBloqueada()">
                        <i class="fas fa-trash"></i> Remover Requerente
                      </button>
                     
                      <button *ngIf="!modoVisualizacaoOrcamento" type="button" class="btn btn-primary btn-orcamento-acao" (click)="salvarOrcamentoCadastroGeral()">
                        <i class="fas fa-save"></i> Salvar
                      </button>
                      <button type="button" class="btn btn-secondary btn-orcamento-acao" (click)="fecharModalCadastroOrcamento()">
                        <i class="fas fa-times"></i> Fechar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="modalObservacaoAberto" class="modal-observacao-overlay">
            <div class="modal-observacao-box">
              <h4>Adicionar Observação</h4>
              <textarea
                rows="5"
                class="form-control"
                [(ngModel)]="observacaoModalTexto"
                name="observacaoModalTexto"
                placeholder="Digite sua observação aqui..."
              ></textarea>
              <div class="form-actions mt-2">
                <button type="button" class="btn btn-primary" (click)="salvarObservacaoModal()">Salvar</button>
                <button type="button" class="btn btn-secondary" (click)="fecharModalObservacao()">Fechar</button>
              </div>
            </div>
          </div>

          <div *ngIf="modalGerarFinanceiroAberto" class="modal-observacao-overlay">
            <div class="modal-observacao-box modal-gerar-financeiro-box">
              <h4>Gerar Financeiro</h4>

              <div class="form-group mb-3">
                <label>Data Vencimento</label>
                <input
                  type="date"
                  class="form-control"
                  [(ngModel)]="dataVencimentoFinanceiro"
                  [ngModelOptions]="{standalone: true}">
              </div>

              <div class="form-group mb-3">
                <label>Tipo de Recebimento</label>
                <select
                  class="form-control"
                  [(ngModel)]="idTipoRecebimentoFinanceiro"
                  [ngModelOptions]="{standalone: true}">
                  <option [ngValue]="0">Selecione</option>
                  <option *ngFor="let item of tiposRecebimentoFinanceiro" [ngValue]="item.id">
                    {{ item.descricao }}
                  </option>
                </select>
                <small class="text-muted" *ngIf="carregandoTiposRecebimentoFinanceiro">Carregando tipos de recebimento...</small>
              </div>

              <div class="form-group mb-3">
                <label for="qtdParcelasFinanceiro">Parcelas</label>
                <input
                  id="qtdParcelasFinanceiro"
                  type="number"
                  class="form-control"
                  min="1"
                  max="120"
                  step="1"
                  [(ngModel)]="qtdParcelasFinanceiro"
                  [ngModelOptions]="{standalone: true}">
                <small class="text-muted">
                  O valor total do orçamento será dividido em parcelas iguais. Vencimentos: 1ª na data informada; demais com +1 mês cada.
                </small>
              </div>

              <div class="form-actions mt-2">
                <button type="button" class="btn btn-primary" (click)="confirmarGeracaoFinanceiroOrcamento()">Gerar</button>
                <button type="button" class="btn btn-secondary" (click)="fecharModalGerarFinanceiro()">Fechar</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Aba Sharepoint -->
      <div class="tab-pane" [class.active]="abaAtiva === 'sharepoint'">
        <div class="tab-header">
          <h2><i class="fas fa-cloud"></i> Sharepoint</h2>
        </div>
        <div class="tab-body">
          
          <!-- Editor de Texto Rich -->
          <div class="sharepoint-editor">
            
            <!-- Barra de Ferramentas -->
            <div class="editor-toolbar">
              <div class="toolbar-group">
                <button type="button" class="btn btn-toolbar" (click)="executarComando('bold')" title="Negrito">
                  <i class="fas fa-bold"></i>
                </button>
                <button type="button" class="btn btn-toolbar" (click)="executarComando('italic')" title="Itálico">
                  <i class="fas fa-italic"></i>
                </button>
                <button type="button" class="btn btn-toolbar" (click)="executarComando('underline')" title="Sublinhado">
                  <i class="fas fa-underline"></i>
                </button>
                <button type="button" class="btn btn-toolbar" (click)="executarComando('strikeThrough')" title="Riscado">
                  <i class="fas fa-strikethrough"></i>
                </button>
              </div>
              
              <div class="toolbar-separator"></div>
              
              <div class="toolbar-group">
                <button type="button" class="btn btn-toolbar" (click)="executarComando('justifyLeft')" title="Alinhar à Esquerda">
                  <i class="fas fa-align-left"></i>
                </button>
                <button type="button" class="btn btn-toolbar" (click)="executarComando('justifyCenter')" title="Centralizar">
                  <i class="fas fa-align-center"></i>
                </button>
                <button type="button" class="btn btn-toolbar" (click)="executarComando('justifyRight')" title="Alinhar à Direita">
                  <i class="fas fa-align-right"></i>
                </button>
                <button type="button" class="btn btn-toolbar" (click)="executarComando('justifyFull')" title="Justificar">
                  <i class="fas fa-align-justify"></i>
                </button>
              </div>
              
              <div class="toolbar-separator"></div>
              
              <div class="toolbar-group">
                <select class="form-control font-size-select" (change)="alterarTamanhoFonte($event)">
                  <option value="1">8px</option>
                  <option value="2">10px</option>
                  <option value="3" selected>12px</option>
                  <option value="4">14px</option>
                  <option value="5">16px</option>
                  <option value="6">18px</option>
                  <option value="7">24px</option>
                </select>
                
                <select class="form-control font-family-select" (change)="alterarFonte($event)">
                  <option value="Arial">Arial</option>
                  <option value="Times New Roman">Times New Roman</option>
                  <option value="Courier New">Courier New</option>
                  <option value="Georgia">Georgia</option>
                  <option value="Verdana">Verdana</option>
                  <option value="Helvetica">Helvetica</option>
                </select>
                
                <input type="color" class="color-picker" (change)="alterarCorTexto($event)" title="Cor do Texto" value="#000000">
              </div>
              
              <div class="toolbar-separator"></div>
              
              <div class="toolbar-group">
                <button type="button" class="btn btn-toolbar" (click)="executarComando('insertUnorderedList')" title="Lista com Marcadores">
                  <i class="fas fa-list-ul"></i>
                </button>
                <button type="button" class="btn btn-toolbar" (click)="executarComando('insertOrderedList')" title="Lista Numerada">
                  <i class="fas fa-list-ol"></i>
                </button>
                <button type="button" class="btn btn-toolbar" (click)="executarComando('outdent')" title="Diminuir Recuo">
                  <i class="fas fa-outdent"></i>
                </button>
                <button type="button" class="btn btn-toolbar" (click)="executarComando('indent')" title="Aumentar Recuo">
                  <i class="fas fa-indent"></i>
                </button>
              </div>
              
              <div class="toolbar-separator"></div>
              
              <div class="toolbar-group">
                <button type="button" class="btn btn-toolbar" (click)="inserirLink()" title="Inserir Link">
                  <i class="fas fa-link"></i>
                </button>
                <button type="button" class="btn btn-toolbar" (click)="inserirImagem()" title="Inserir Imagem">
                  <i class="fas fa-image"></i>
                </button>
                <button type="button" class="btn btn-toolbar" (click)="inserirTabela()" title="Inserir Tabela">
                  <i class="fas fa-table"></i>
                </button>
                <button type="button" class="btn btn-toolbar" (click)="inserirLinhaHorizontal()" title="Linha Horizontal">
                  <i class="fas fa-minus"></i>
                </button>
              </div>
              
              <div class="toolbar-separator"></div>
              
              <div class="toolbar-group">
                <button type="button" class="btn btn-toolbar" (click)="desfazer()" title="Desfazer">
                  <i class="fas fa-undo"></i>
                </button>
                <button type="button" class="btn btn-toolbar" (click)="refazer()" title="Refazer">
                  <i class="fas fa-redo"></i>
                </button>
                <button type="button" class="btn btn-toolbar" (click)="limparFormatacao()" title="Limpar Formatação">
                  <i class="fas fa-remove-format"></i>
                </button>
              </div>
            </div>
            
            <!-- Área de Edição -->
            <div class="editor-container">
              <div 
                class="editor-content" 
                contenteditable="true" 
                #editorContent
                (input)="onContentChange()"
                (paste)="onPaste($event)"
                (keydown)="onKeyDown($event)">
                
            
              </div>
            </div>
            
            <!-- Barra de Status -->
            <div class="editor-status">
              <div class="status-info">
                <span class="status-item">
                  <i class="fas fa-font"></i>
                  <span id="current-font">{{ fonteAtual }}</span>
                </span>
                <span class="status-item">
                  <i class="fas fa-text-height"></i>
                  <span id="current-size">{{ tamanhoFonteAtual }}px</span>
                </span>
                <span class="status-item">
                  <i class="fas fa-palette"></i>
                  <span id="current-color">{{ corTextoAtual }}</span>
                </span>
              </div>
              <div class="status-actions">
                <button type="button" class="btn btn-sm btn-outline" (click)="salvarConteudo()" title="Salvar Conteúdo">
                  <i class="fas fa-save"></i> Salvar
                </button>
                <button type="button" class="btn btn-sm btn-outline" (click)="carregarConteudo()" title="Carregar Conteúdo">
                  <i class="fas fa-folder-open"></i> Carregar
                </button>
                <button type="button" class="btn btn-sm btn-outline" (click)="limparConteudo()" title="Limpar Conteúdo">
                  <i class="fas fa-eraser"></i> Limpar
                </button>
                <button type="button" class="btn btn-sm btn-outline" (click)="exportarConteudo()" title="Exportar Conteúdo">
                  <i class="fas fa-download"></i> Exportar
                </button>
              </div>
            </div>
            
          </div>
          
        </div>
      </div>

      <!-- Aba Responsável -->
      <div class="tab-pane" [class.active]="abaAtiva === 'responsavel'">
        <div class="tab-header">
          <h2><i class="fas fa-user-tie"></i> Responsável</h2>
        </div>
        <div class="tab-body cad-responsavel-cliente-panel">

          <div *ngIf="!idPacienteEdicao || idPacienteEdicao <= 0" class="alert alert-warning mb-3">
            Salve o cliente antes de vincular responsáveis nesta aba.
          </div>

          <div class="cad-responsavel-cliente-lista-wrap" *ngIf="idPacienteEdicao > 0">
            <small class="text-muted" *ngIf="carregandoResponsavelCliente">Carregando responsáveis...</small>
            <table class="table table-sm table-striped cad-responsavel-cliente-tabela" *ngIf="!carregandoResponsavelCliente">
              <thead>
                <tr>
                  <th>Responsável</th>
                  <th style="width: 90px;">Sigla</th>
                  <th style="width: 160px;">Data</th>
                  <th style="width: 120px;" class="text-center">Setar</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let linha of responsavelClienteLinhas">
                  <td>{{ linha.responsavel }}</td>
                  <td>{{ linha.sigla }}</td>
                  <td>
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      [(ngModel)]="linha.data"
                      [ngModelOptions]="{ standalone: true }" />
                  </td>
                  <td class="text-center align-middle col-responsavel-setar">
                    <div class="toggle-container responsavel-setar-toggle">
                      <label class="toggle-switch" [attr.for]="'respSetar' + linha.idCadResponsavel">
                        <input
                          type="checkbox"
                          [id]="'respSetar' + linha.idCadResponsavel"
                          [(ngModel)]="linha.setar"
                          [ngModelOptions]="{ standalone: true }" />
                        <span class="toggle-slider"></span>
                      </label>
                      <span class="toggle-label">{{ linha.setar ? 'Sim' : 'Não' }}</span>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="responsavelClienteLinhas.length === 0">
                  <td colspan="4" class="text-center text-muted">
                    Nenhum responsável cadastrado no sistema. Use Administração → Responsável.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="cad-responsavel-cliente-toolbar" *ngIf="idPacienteEdicao > 0">
            <button
              type="button"
              class="btn btn-sm btn-success"
              (click)="salvarResponsavelCliente()"
              [disabled]="salvandoResponsavelCliente || carregandoResponsavelCliente">
              <i class="fas fa-save"></i>
              {{ salvandoResponsavelCliente ? 'Salvando...' : 'Salvar vínculos' }}
            </button>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="modalTipoDocumentoBuscaBrasilAberto" class="modal-observacao-overlay" (click)="fecharModalTipoDocumentoBuscaBrasil()">
  <div class="modal-observacao-box modal-tipo-documento-busca-brasil-box" (click)="$event.stopPropagation()">
    <h4><i class="fas fa-file-medical"></i> Tipos de documento — Busca Brasil</h4>
    <p class="modal-tipo-documento-hint text-muted">
      Cadastre os documentos disponíveis na coluna <strong>Documento a ser providenciado</strong>.
    </p>

    <div class="modal-tipo-documento-form">
      <div class="form-row">
        <div class="form-group col-md-5">
          <label>Título</label>
          <input
            type="text"
            class="form-control form-control-sm"
            [(ngModel)]="tipoDocumentoBuscaBrasilFormTitulo"
            [ngModelOptions]="{ standalone: true }"
            maxlength="120"
            placeholder="Ex.: Nascimento">
        </div>
        <div class="form-group col-md-5">
          <label>Descrição</label>
          <input
            type="text"
            class="form-control form-control-sm"
            [(ngModel)]="tipoDocumentoBuscaBrasilFormDescricao"
            [ngModelOptions]="{ standalone: true }"
            maxlength="255"
            placeholder="Opcional">
        </div>
        <div class="form-group col-md-2 modal-tipo-documento-form-acoes">
          <label>&nbsp;</label>
          <button
            type="button"
            class="btn btn-sm btn-success btn-block"
            (click)="salvarTipoDocumentoBuscaBrasil()"
            [disabled]="salvandoTipoDocumentoBuscaBrasil">
            <i class="fas fa-save"></i>
            {{ tipoDocumentoBuscaBrasilEditando ? 'Atualizar' : 'Incluir' }}
          </button>
        </div>
      </div>
      <button
        *ngIf="tipoDocumentoBuscaBrasilEditando"
        type="button"
        class="btn btn-link btn-sm p-0 modal-tipo-documento-cancelar-edicao"
        (click)="novoTipoDocumentoBuscaBrasil()">
        Cancelar edição
      </button>
    </div>

    <div class="modal-tipo-documento-lista-wrap">
      <small class="text-muted" *ngIf="carregandoTiposDocumentoBuscaBrasilModal">Carregando lista...</small>
      <table class="table table-sm table-striped modal-tipo-documento-tabela" *ngIf="!carregandoTiposDocumentoBuscaBrasilModal">
        <thead>
          <tr>
            <th>Título</th>
            <th>Descrição</th>
            <th class="col-acoes-modal">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of tiposDocumentoBuscaBrasilModalLista">
            <td>{{ item.titulo }}</td>
            <td>{{ item.descricao || '—' }}</td>
            <td class="col-acoes-modal">
              <button type="button" class="btn btn-link btn-sm p-0 mr-2" title="Editar" (click)="editarTipoDocumentoBuscaBrasil(item)">
                <i class="fas fa-edit"></i>
              </button>
              <button type="button" class="btn btn-link btn-sm p-0 text-danger" title="Excluir" (click)="excluirTipoDocumentoBuscaBrasil(item)">
                <i class="fas fa-trash-alt"></i>
              </button>
            </td>
          </tr>
          <tr *ngIf="tiposDocumentoBuscaBrasilModalLista.length === 0">
            <td colspan="3" class="text-center text-muted">Nenhum tipo cadastrado.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="modal-observacao-acoes">
      <button type="button" class="btn btn-secondary" (click)="fecharModalTipoDocumentoBuscaBrasil()">
        Fechar
      </button>
    </div>
  </div>
</div>

<div *ngIf="modalTipoDocumentoBuscaItaliaAberto" class="modal-observacao-overlay" (click)="fecharModalTipoDocumentoBuscaItalia()">
  <div class="modal-observacao-box modal-tipo-documento-busca-brasil-box" (click)="$event.stopPropagation()">
    <h4><i class="fas fa-file-medical"></i> Tipos de documento — Busca Itália</h4>
    <p class="modal-tipo-documento-hint text-muted">
      Cadastre os documentos disponíveis na coluna <strong>Documento a ser providenciado</strong>.
    </p>

    <div class="modal-tipo-documento-form">
      <div class="form-row">
        <div class="form-group col-md-5">
          <label>Título</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="tipoDocumentoBuscaItaliaFormTitulo" [ngModelOptions]="{ standalone: true }" maxlength="120" placeholder="Ex.: Nascimento">
        </div>
        <div class="form-group col-md-5">
          <label>Descrição</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="tipoDocumentoBuscaItaliaFormDescricao" [ngModelOptions]="{ standalone: true }" maxlength="255" placeholder="Opcional">
        </div>
        <div class="form-group col-md-2 modal-tipo-documento-form-acoes">
          <label>&nbsp;</label>
          <button type="button" class="btn btn-sm btn-success btn-block" (click)="salvarTipoDocumentoBuscaItalia()" [disabled]="salvandoTipoDocumentoBuscaItalia">
            <i class="fas fa-save"></i>
            {{ tipoDocumentoBuscaItaliaEditando ? 'Atualizar' : 'Incluir' }}
          </button>
        </div>
      </div>
      <button *ngIf="tipoDocumentoBuscaItaliaEditando" type="button" class="btn btn-link btn-sm p-0 modal-tipo-documento-cancelar-edicao" (click)="novoTipoDocumentoBuscaItalia()">
        Cancelar edição
      </button>
    </div>

    <div class="modal-tipo-documento-lista-wrap">
      <small class="text-muted" *ngIf="carregandoTiposDocumentoBuscaItaliaModal">Carregando lista...</small>
      <table class="table table-sm table-striped modal-tipo-documento-tabela" *ngIf="!carregandoTiposDocumentoBuscaItaliaModal">
        <thead>
          <tr>
            <th>Título</th>
            <th>Descrição</th>
            <th class="col-acoes-modal">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of tiposDocumentoBuscaItaliaModalLista">
            <td>{{ item.titulo }}</td>
            <td>{{ item.descricao || '—' }}</td>
            <td class="col-acoes-modal">
              <button type="button" class="btn btn-link btn-sm p-0 mr-2" title="Editar" (click)="editarTipoDocumentoBuscaItalia(item)">
                <i class="fas fa-edit"></i>
              </button>
              <button type="button" class="btn btn-link btn-sm p-0 text-danger" title="Excluir" (click)="excluirTipoDocumentoBuscaItalia(item)">
                <i class="fas fa-trash-alt"></i>
              </button>
            </td>
          </tr>
          <tr *ngIf="tiposDocumentoBuscaItaliaModalLista.length === 0">
            <td colspan="3" class="text-center text-muted">Nenhum tipo cadastrado.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="modal-observacao-acoes">
      <button type="button" class="btn btn-secondary" (click)="fecharModalTipoDocumentoBuscaItalia()">
        Fechar
      </button>
    </div>
  </div>
</div>

<div *ngIf="modalTipoDocumentoTraducaoAberto" class="modal-observacao-overlay" (click)="fecharModalTipoDocumentoTraducao()">
  <div class="modal-observacao-box modal-tipo-documento-busca-brasil-box" (click)="$event.stopPropagation()">
    <h4><i class="fas fa-file-medical"></i> Tipos de documento — Tradução</h4>
    <p class="modal-tipo-documento-hint text-muted">
      Cadastre os documentos disponíveis na coluna <strong>Documento a ser traduzido</strong>.
    </p>

    <div class="modal-tipo-documento-form">
      <div class="form-row">
        <div class="form-group col-md-5">
          <label>Título</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="tipoDocumentoTraducaoFormTitulo" [ngModelOptions]="{ standalone: true }" maxlength="120" placeholder="Ex.: Nascimento">
        </div>
        <div class="form-group col-md-5">
          <label>Descrição</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="tipoDocumentoTraducaoFormDescricao" [ngModelOptions]="{ standalone: true }" maxlength="255" placeholder="Opcional">
        </div>
        <div class="form-group col-md-2 modal-tipo-documento-form-acoes">
          <label>&nbsp;</label>
          <button type="button" class="btn btn-sm btn-success btn-block" (click)="salvarTipoDocumentoTraducao()" [disabled]="salvandoTipoDocumentoTraducao">
            <i class="fas fa-save"></i>
            {{ tipoDocumentoTraducaoEditando ? 'Atualizar' : 'Incluir' }}
          </button>
        </div>
      </div>
      <button *ngIf="tipoDocumentoTraducaoEditando" type="button" class="btn btn-link btn-sm p-0 modal-tipo-documento-cancelar-edicao" (click)="novoTipoDocumentoTraducao()">
        Cancelar edição
      </button>
    </div>

    <div class="modal-tipo-documento-lista-wrap">
      <small class="text-muted" *ngIf="carregandoTiposDocumentoTraducaoModal">Carregando lista...</small>
      <table class="table table-sm table-striped modal-tipo-documento-tabela" *ngIf="!carregandoTiposDocumentoTraducaoModal">
        <thead>
          <tr>
            <th>Título</th>
            <th>Descrição</th>
            <th class="col-acoes-modal">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of tiposDocumentoTraducaoModalLista">
            <td>{{ item.titulo }}</td>
            <td>{{ item.descricao || '—' }}</td>
            <td class="col-acoes-modal">
              <button type="button" class="btn btn-link btn-sm p-0 mr-2" title="Editar" (click)="editarTipoDocumentoTraducao(item)">
                <i class="fas fa-edit"></i>
              </button>
              <button type="button" class="btn btn-link btn-sm p-0 text-danger" title="Excluir" (click)="excluirTipoDocumentoTraducao(item)">
                <i class="fas fa-trash-alt"></i>
              </button>
            </td>
          </tr>
          <tr *ngIf="tiposDocumentoTraducaoModalLista.length === 0">
            <td colspan="3" class="text-center text-muted">Nenhum tipo cadastrado.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="modal-observacao-acoes">
      <button type="button" class="btn btn-secondary" (click)="fecharModalTipoDocumentoTraducao()">
        Fechar
      </button>
    </div>
  </div>
</div>


